// noinspection SpellCheckingInspection

import {CollectionType} from "./types";
import {LanguageLocaleEnum, Translation, TranslationCreate} from "../client/api";

type Keyword = {
  [T in LanguageLocaleEnum]: string;
};

type Keywords = {
  [T in string]: Keyword;
};

const generalKeywords = {
  welcome: {
    de: "Willkommen, bitte anmelden!",
    it: "Benvenuto, per favore accedere!",
    en: "Welcome, please login!",
  },
  me: {
    de: "Ich",
    it: "Io",
    en: "Me",
  },
  loading: {
    de: "Lade...",
    it: "Caricamento...",
    en: "Loading...",
  },
  match: {
    de: "Spiel",
    it: "Partita",
    en: "Match",
  },
  settings: {
    de: "Einstellungen",
    it: "Impostazioni",
    en: "Settings",
  },
  language: {
    de: "Sprache",
    it: "Lingua",
    en: "Language",
  },
  theme: {
    de: "Motiv",
    it: "Tema",
    en: "Theme",
  },
  sport: {
    de: "Sportart",
    it: "Sport",
    en: "Sport",
  },
  switchToLight: {
    de: "Zu Hell wechseln",
    it: "Passa a Chiaro",
    en: "Switch to Light",
  },
  switchToDark: {
    de: "Zu Dunkel wechseln",
    it: "Passa a Scuro",
    en: "Switch to Dark",
  },
  not_implemented: {
    de: "Noch nicht implementiert.",
    it: "Non ancora implementato.",
    en: "Not implemented yet.",
  },
  credentials_wrong: {
    de: "Anmeldedaten nicht korrekt",
    it: "Dati di accesso errati",
    en: "Wrong credentials supplied",
  },
  serverError: {
    de: "Es hat sich ein Serverproblem ergeben, bitte später probieren.",
    it: "Si è verificato un problema con il server, riprova più tardi.",
    en: "There is a server error, please try again later.",
  },
  noConnection: {
    de: "Bitte kontrolliere deine Verbindung zum Internet!",
    it: "Controlla la tua conessione internet!",
    en: "Please check your connection to the internet!",
  },
  whoops: {
    de: "Whoops",
    it: "Whoops",
    en: "Whoops",
  },
  chooseProvince: {
    de: "Welche Region ist für dich von Interesse?",
    it: "Quale regione ti interessa?",
    en: "What region is of interest to you?",
  },
  no_user_found: {
    de: "User nicht gefunden!",
    it: "User non trovato!",
    en: "User not found!",
  },
  not_registered: {
    de: "Noch nicht registriert",
    it: "Non registrato",
    en: "Not registered",
  },
  notRegisteredInvite: {
    de: "Noch nicht registriert?",
    it: "Non sei ancora registrato?",
    en: "Not registered yet?",
  },
  createAccount: {
    de: "Erstelle ein Konto",
    it: "Crea un account",
    en: "Create an account",
  },
  login_required: {
    de: "Anmeldung erforderlich",
    it: "Login necessario",
    en: "Login required",
  },
  logInSuccess: {
    de: "Erfolgreich angemeldet",
    it: "Effettuato il login con successo",
    en: "Logged in successfully",
  },
  skip: {
    de: "Überspringen",
    it: "Salta",
    en: "Skip",
  },
  continue: {
    de: "Weiter",
    it: "Continua",
    en: "Continue",
  },
  choose_picker: {
    de: "-- Bitte wählen --",
    it: "-- Seleziona --",
    en: "-- Choose --",
  },
  first_open: {
    de: "In welcher Sprache möchtest du die App nutzen?",
    it: "In quale lingua vorresti utilizzare l'app?",
    en: "In which language would you like to use the app?",
  },
  first_open_title: {
    de: "ALLGEMEIN",
    it: "GENERALMENTE",
    en: "GENERALLY",
  },
  first_open_settings_title: {
    de: "Basiseinstellungen",
    it: "Impostazioni di base",
    en: "Basic settings",
  },
  first_open_settings_description: {
    de: "In welcher Sprache möchtest du die App nutzen?",
    it: "In quale lingua vorresti utilizzare l'app?",
    en: "In which language would you like to use the app?",
  },
  first_open_settings_language_label: {
    de: "Sprache wählen",
    it: "Seleziona la tua lingua",
    en: "Select your language",
  },
  general: {
    de: "Allgemein",
    it: "Generale",
    en: "General",
  },
  error_occurred: {
    de: "Ups... da ist ein Fehler aufgetreten!",
    it: "Ops... si è verificato un errore!",
    en: "Ops... we're encountering some issues!",
  },
  matches: {
    de: "Spiele",
    it: "Partite",
    en: "Matches",
  },
  favorites: {
    de: "Favoriten",
    it: "Preferiti",
    en: "Favorites",
  },
  follow: {
    de: "Folgen",
    it: "Segui",
    en: "Follow",
  },
  following: {
    de: "Gefolgt",
    it: "Seguito",
    en: "Following",
  },
  nextmatches: {
    de: "Nächste partite",
    it: "Prossime partite",
    en: "Next matches",
  },
  table: {
    de: "Tabelle",
    it: "Classifica",
    en: "Table",
  },
  statistics: {
    de: "Statistiken",
    it: "Statistiche",
    en: "Statistics",
  },
  transfers: {
    de: "Transfers",
    it: "Video",
    en: "Videos",
  },
  videos: {
    de: "Videos",
    it: "Video",
    en: "Videos",
  },
  bulletins: {
    de: "Rundschreiben",
    it: "Communicati",
    en: "Bulletins",
  },
  noMatches: {
    de: "Keine Spiele",
    en: "No matches",
    it: "Nessuna partita",
  },
  matchDay: {
    de: "Spieltag",
    it: "Giornata",
    en: "Matchday ",
  },
  matchDays: {
    de: "Spieltage insgesamt",
    it: "Giornate totale",
    en: "Matchdays total ",
  },
  hasPlayerStatistics: {
    de: "Hat Spieler-Stats",
    it: "Hat Spieler-Stats",
    en: "Hat Spieler-Stats",
  },
  hasTeamStatistics: {
    de: "Hat Team-Stats",
    it: "Hat Team-Stats",
    en: "Hat Team-Stats",
  },
  hasManOfTheMatch: {
    de: "Hat MOTM",
    it: "Hat MOTM",
    en: "Hat MOTM",
  },
  hasLineup: {
    de: "Hat Lineup",
    it: "Hat Lineup",
    en: "Hat Lineup",
  },
  hasFeed: {
    de: "Hat Feed",
    it: "Hat Feed",
    en: "Hat Feed",
  },
  hasScorers: {
    de: "Hat Torschützen",
    it: "Hat Torschützen",
    en: "Hat Torschützen",
  },
  hasSquad: {
    de: "Hat Kader",
    it: "Hat Kader",
    en: "Hat Kader",
  },
  hasBetting: {
    de: "Hat Glücksspiel",
    it: "Hat Glücksspiel",
    en: "Hat Glücksspiel",
  },
  amountPlayers: {
    de: "Anzahl Spieler pro Team",
    it: "Anzahl Spieler pro Team",
    en: "Anzahl Spieler pro Team",
  },
  loadingMatches: {
    de: "Spiele werden geladen",
    it: "Caricamento partite",
    en: "Loading matches",
  },
  chooseMatchday: {
    de: "Spieltag wählen",
    it: "Seleziona giornata",
    en: "Select matchday",
  },
  chooseDate: {
    de: "Datum wählen",
    it: "Selezionare la data",
    en: "Choose date",
  },
  againExit: {
    de: "Drücke nochmal, um die App zu schließen",
    it: "Premi di nuovo per chiudere l'app",
    en: "Press again to close the app",
  },
  overall: {
    de: "Gesamt",
    it: "Totale",
    en: "Total",
  },
  home: {
    de: "Home",
    it: "Home",
    en: "Home",
  },
  away: {
    de: "Auswärts",
    it: "Trasferta",
    en: "Away",
  },
  share: {
    de: "teilen",
    it: "condividi",
    en: "share",
  },
  shareTitle: {
    de: "Teilen",
    it: "Condividi",
    en: "Share",
  },
  tie: {
    de: "Unentschieden",
    it: "Pareggio",
    en: "Tie",
  },
  difference: {
    de: "DIF",
    it: "DIF",
    en: "DIF",
  },
  matchesShort: {
    de: "SP",
    it: "G",
    en: "M",
  },
  points: {
    de: "PT",
    it: "PT",
    en: "PTS",
  },
  halftime: {
    de: "Halbzeit",
    it: "Intervallo",
    en: "Halftime",
  },
  fulltime: {
    de: "Ende",
    it: "Fine",
    en: "Fulltime",
  },
  reportError: {
    de: "Fehler melden",
    it: "Segnala errore",
    en: "Report error",
  },
  lineupMissing: {
    de: "Keine Aufstellung eingetragen",
    it: "Nessuna formazione inserita",
    en: "Lineup missing",
  },
  changes: {
    de: "Wechsel",
    it: "Cambi",
    en: "Changes",
  },
  noChanges: {
    de: "Keine Wechsel",
    it: "Nessun cambio",
    en: "No changes",
  },
  shareScore: {
    de: "Ergebniss [team1] - [team2]: [goal1] - [goal2]! \nGesehen auf Clava!",
    it: "Risultato [team1] - [team2]: [goal1] - [goal2]! \nGesehen auf Clava!",
    en: "Result [team1] - [team2]: [goal1] - [goal2]! \nGesehen auf Clava!",
  },
  noLineupEntered: {
    de: "Keine Aufstellung eingetragen!",
    it: "Nessuna formazione inserita!",
    en: "Lineup not entered!",
  },
  noEventsEntered: {
    de: "Keine Ereignisse eingetragen!",
    it: "Nessuna evento inserita!",
    en: "No events entered!",
  },
  writeHere: {
    de: "Schreibe...",
    it: "Inserisci...",
    en: "Write here...",
  },
  downloadUnlimited: {
    de: "Laden Sie die Clava Sports App herunter, um auf unbegrenzte Funktionen zuzugreifen",
    it: "Scarica l'app Clava Sports per accedere a funzionalità illimitate",
    en: "Download Clava Sports App to Access to Unlimited Features",
  },
  downloadApp: {
    de: "Clava-App jetzt herunterladen",
    it: "Scarica l'App Clava adesso",
    en: "Downlaod Clava App Now",
  },
  downloadAppTitle: {
    de: "App herunterladen",
    it: "Scarica app",
    en: "Download app",
  },
  downloadNow: {
    de: "Jetzt Downloaden",
    it: "Scarica Adesso",
    en: "Download Now",
  },
  results: {
    de: "Ergebnisse",
    it: "Risultati",
    en: "Hits",
  },
  options: {
    de: "Optionen",
    it: "Optioni",
    en: "Options",
  },
  usefulInfo: {
    de: "Nützliche Info",
    it: "Info utile",
    en: "Useful Info",
  },
  lastMatch: {
    de: "Letztes Spiel",
    it: "Ultima partita",
    en: "Last match",
  },
  lastMatches: {
    de: "Letzte Spiele",
    it: "Ultime partite",
    en: "Last matches",
  },
  select: {
    de: "Wählen",
    it: "Seleziona",
    en: "Select",
  },
  prevQueries: {
    de: "Suchverlauf...",
    it: "Storia della ricerca...",
    en: "Search history...",
  },
  searches: {
    de: "Anfragen",
    it: "Richieste",
    en: "Searches",
  },
  showAll: {
    de: "Mehr anzeigen",
    it: "Mostra di più",
    en: "Show more",
  },
  showLess: {
    de: "Weniger anzeigen",
    it: "Mostra di meno",
    en: "Show less",
  },
  showMore: {
    de: "Mehr anzeigen",
    it: "Mostra di più",
    en: "Show more",
  },
  matchesDone: {
    de: "Bereits gespielt",
    it: "Terminate",
    en: "Already finished",
  },
  alreadyPlayed: {
    de: "Bereits gespielt",
    it: "Giocate",
    en: "Already played",
  },
  matchesToPlay: {
    de: "Noch zu spielen",
    it: "Ancora da giocare",
    en: "Yet to play",
  },
  mainSponsors: {
    de: "Hauptsponsoren",
    it: "Sponsor principali",
    en: "Main sponsor",
  },
  teamInfo: {
    de: "Vereinsinfos",
    it: "Info società",
    en: "Club info",
  },
  noMinutesShort: {
    de: "k.A.",
    it: "N/A",
    en: "k.A.",
  },
  morePostsInApp: {
    de: "Viele weitere Feed Beiträge findest du in unserer App",
    it: "Puoi trovare molti altri post di feed nella nostra app",
    en: "You can find many more feed posts in our app",
  },
  SOCCER: {
    de: "Fußball",
    it: "Calcio",
    en: "Soccer",
  },
  HOCKEY: {
    de: "Eishockey",
    it: "Hockey",
    en: "Hockey",
  },
  VOLLEYBALL: {
    de: "Volleyball",
    it: "Pallavolo",
    en: "Volleyball",
  },
  teamLocation: {
    de: "Spielstätte",
    it: "Stadio",
    en: "Stadium",
  },
  teamFounded: {
    de: "Gründungsjahr",
    it: "Anno di fondazione",
    en: "Foundation year",
  },
  teamPresident: {
    de: "Präsident",
    it: "Presidente",
    en: "President",
  },
  teamTel: {
    de: "Telefon",
    it: "Telefono",
    en: "Phone",
  },
  teamMail: {
    de: "E-Mail",
    it: "E-mail",
    en: "Email",
  },
  teamtitle: {
    de: "Erfolge",
    it: "Titoli",
    en: "Trophies",
  },
  minutes: {
    de: "Min",
    it: "Min",
    en: "Min",
  },
  goals: {
    de: "Tore",
    it: "Gol",
    en: "Goals",
  },
  wins: {
    de: "W",
    it: "V",
    en: "W",
  },
  draws: {
    de: "D",
    it: "N",
    en: "D",
  },
  losses: {
    de: "L",
    it: "P",
    en: "L",
  },
  goalsOut: {
    de: "F",
    it: "F",
    en: "F",
  },
  goalsIn: {
    de: "A",
    it: "S",
    en: "A",
  },
  lineup: {
    de: "Lineup",
    it: "Formazione",
    en: "Lineup",
  },
  starting11: {
    de: "Starting 11",
    it: "Starting 11",
    en: "Starting 11",
  },
  list: {
    de: "Liste",
    it: "Lista",
    en: "List",
  },
  teams: {
    de: "Mannschaften",
    it: "Squadre",
    en: "Teams",
  },
  leagues: {
    de: "Ligen",
    it: "Campionati",
    en: "Leagues",
  },
  players: {
    de: "Spieler",
    it: "Giocatori",
    en: "Players",
  },
  darkMode: {
    de: "Dark Mode",
    it: "Dark Mode",
    en: "Dark Mode",
  },
  notifications: {
    de: "Benachrichtigungen",
    it: "Notifiche",
    en: "Notifications",
  },
  areaOfInterest: {
    de: "Provinz",
    it: "Provincia",
    en: "Provinz",
  },
  chooseAoi: {
    de: "Provinz wechseln",
    it: "Cambia provincia",
    en: "Change area",
  },
  contactUs: {
    de: "Kontaktiere uns",
    it: "Contattaci",
    en: "Contact us",
  },
  rateUs: {
    de: "Bewerte uns",
    it: "Scrivi una recensione",
    en: "Rate us",
  },
  adsOnClava: {
    de: "Deine Werbung auf Clava",
    it: "Fai pubblicità su Clava",
    en: "Your ads on Clava",
  },
  aboutUs: {
    de: "Über uns",
    it: "Chi siamo",
    en: "About us",
  },
  company: {
    de: "Unternehmen",
    it: "Azienda",
    en: "Company",
  },
  legal: {
    de: "Rechtliches",
    it: "Legale",
    en: "Legal",
  },
  usefulLinks: {
    de: "Nützliche link",
    it: "Link utili",
    en: "Useful links",
  },
  whyClava: {
    de: "Warum Clava",
    it: "Perché Clava",
    en: "Why Clava",
  },
  faq: {
    de: "FAQ",
    it: "FAQ",
    en: "FAQ",
  },
  shareFriends: {
    de: "Mit Freunden teilen",
    it: "Condividi con amici",
    en: "Share with friends",
  },
  impressum: {
    de: "Impressum",
    it: "Impressum",
    en: "Impressum",
  },
  privacy: {
    de: "Datenschutzerklärung",
    it: "Informativa sulla privacy",
    en: "Privacy policy",
  },
  tos: {
    de: "Nutzungsbedingungen",
    it: "Termini di utilizzo",
    en: "Terms of Use",
  },
  cancelledShort: {
    de: "Abg.",
    it: "Ann",
    en: "Can",
  },
  cancelledFull: {
    de: "Abgesagt",
    it: "Annullato",
    en: "Canceled",
  },
  addTeam: {
    de: "Mannschaft hinzufügen",
    it: "Aggiungi squadra",
    en: "Add team",
  },
  noFavsFor: {
    de: "Oh... noch [type] favorisiert",
    it: "Oh... noch [type] favorisato",
    en: "Oh... [type] favorites",
  },
  noTeam: {
    de: "Keine Mannschaft",
    it: "Nessuna squadra",
    en: "No team",
  },
  noMatch: {
    de: "Kein Spiel",
    it: "Nessuna partita",
    en: "No match",
  },
  register: {
    de: "Registrieren",
    it: "Registrati",
    en: "Register",
  },
  login: {
    de: "Anmelden",
    it: "Accedi",
    en: "Login",
  },
  accediOra: {
    de: "Zur Verwaltung",
    it: "Vai al Team Management",
    en: "Go to Team Management",
  },
  logout: {
    de: "Abmelden",
    it: "Esci",
    en: "Log out",
  },
  alreadyRegistered: {
    de: "Hast du bereits ein Profil?",
    it: "Hai già un profilo?",
    en: "Do you already have a profile?",
  },
  beInsider: {
    de: "Clava Insider werden",
    it: "Diventa Clava Insider",
    en: "Become Clava Insider",
  },
  insider: {
    de: "Insider",
    it: "Insider",
    en: "Insider",
  },
  dev: {
    de: "DEV",
    it: "DEV",
    en: "DEV",
  },
  prod: {
    de: "PROD",
    it: "PROD",
    en: "PROD",
  },
  beta: {
    de: "BETA",
    it: "BETA",
    en: "BETA",
  },
  teamInsider: {
    de: "Vereinsmanager",
    it: "Club manager",
    en: "Club manager",
  },
  yourTeams: {
    de: "Meine Mannschaften",
    it: "Le mie squadre",
    en: "My teams",
  },
  moreStats: {
    de: "MEHR STATISTIKEN,",
    it: "PIÙ STATISTICHE,",
    en: "MORE STATISTICS,",
  },
  moreInsights: {
    de: "MEHR INSIGHTS,",
    it: "PIÙ NOTIZIE,",
    en: "MORE INSIGHTS,",
  },
  moreSport: {
    de: "MEHR SPORT!",
    it: "PIÙ SPORT!",
    en: "MORE SPORT!",
  },
  premium: {
    de: "Clava Premium",
    it: "Clava Premium",
    en: "Clava Premium",
  },
  welcomePremium: {
    de: "WILLKOMMEN BEI CLAVA PREMIUM",
    it: "BENVENUTO DA CLAVA PREMIUM",
    en: "WELCOME AT CLAVA PREMIUM",
  },
  welcomeInsider: {
    de: "WERDE CLAVA INSIDER",
    it: "DIVENTA CLAVA INSIDER",
    en: "BECOME CLAVA INSIDER",
  },
  givenName: {
    de: "Vorname",
    it: "Nome",
    en: "Given Name",
  },
  familyName: {
    de: "Nachname",
    it: "Cognome",
    en: "Family Name",
  },
  mailAddress: {
    de: "E-Mail Adresse",
    it: "Indirizzo e-mail",
    en: "Email address",
  },
  yourAdsOnClava: {
    de: "Deine Werbung auf Clava",
    it: "La tua pubblicità su Clava",
    en: "Your ads on Clava",
  },
  password: {
    de: "Passwort",
    it: "Password",
    en: "Password",
  },
  passwordRepeat: {
    de: "Passwort wiederholen",
    it: "Ripeti password",
    en: "Repeat password",
  },
  pwNotSame: {
    de: "Passwörter stimmen nicht überein",
    it: "Le passwords non corrispondono",
    en: "Passwords do not match",
  },
  mailInvalid: {
    de: "E-Mail Adresse ungültig",
    it: "Indirizzo e-mail non valido",
    en: "Email invalid",
  },
  mailGiven: {
    de: "E-Mail Adresse bereits vergeben",
    it: "Indirizzo e-mail già utilizzato",
    en: "Email adress already taken",
  },
  usernameGiven: {
    de: "Benutzername bereits vergeben",
    it: "Nome utente già utilizzato",
    en: "Username already taken",
  },
  failed: {
    de: "Fehler bei der Registrierung",
    it: "Errore durante la registrazione",
    en: "Registration failed",
  },
  pwNotValid: {
    de: "Passwort unsicher",
    it: "Password incerta",
    en: "Password not safe enough",
  },
  pwWrong: {
    de: "E-Mail oder Passwort falsch",
    it: "E-mail o password errata",
    en: "Email or passwort wrong",
  },
  telWrong: {
    de: "Telefonnummer oder Passwort falsch",
    it: "Numero di telefono o password errata",
    en: "Phone number or password wrong",
  },
  notRegistered: {
    de: "Benutzer nicht gefunden",
    it: "Utente non trovato",
    en: "User not found",
  },
  registerNow: {
    de: "Konto erstellen",
    it: "Crea un account",
    en: "Create account",
  },
  confirmMailShort: {
    de: "E-Mail bestätigen",
    it: "Conferma e-mail",
    en: "Confirm email",
  },
  loginPendingTitle: {
    de: "SMS überprüfen",
    it: "Controlla gli SMS",
    en: "Check your SMS",
  },
  loginPendingDesc: {
    de: "Öffne den Link aus der SMS auf deinem Smartphone, um den Login abzuschließen. Diese Seite aktualisiert sich automatisch.",
    it: "Apri il link ricevuto via SMS sul tuo smartphone per completare l'accesso. Questa pagina si aggiornerà automaticamente.",
    en: "Open the link in the SMS on your smartphone to complete the login. This page will update automatically.",
  },
  resendSms: {
    de: "SMS erneut senden",
    it: "Reinvia SMS",
    en: "Resend SMS",
  },
  resendCode: {
    de: "Code erneut senden",
    it: "Reinvia codice",
    en: "Resend code",
  },
  resendAvailableIn: {
    de: "Erneut senden möglich in",
    it: "Puoi reinviare tra",
    en: "Resend available in",
  },
  chooseTeamInsider: {
    de: "Für welche Mannschaft möchtest du eintragen?",
    it: "Per quale squadra vuoi inserire?",
    en: "Which team would you like to manage?",
  },
  confirmMail: {
    de: "E-Mail bestätigen",
    it: "Conferma email",
    en: "Confirm email",
  },
  confirmMailInfoLink: {
    de: "Wir haben dir eine E‑Mail mit einem Link gesendet. Öffne ihn, um deine Adresse zu bestätigen.",
    it: "Ti abbiamo inviato un'email con un link. Aprilo per verificare il tuo indirizzo.",
    en: "We sent you an email with a link. Open it to verify your address.",
  },
  confirmMailInviteLink: {
    de: "Bestätige jetzt deine E‑Mail-Adresse.",
    it: "Conferma ora il tuo indirizzo email.",
    en: "Confirm your email address now.",
  },
  sendCode: {
    de: "Code senden",
    it: "Invia codice",
    en: "Send code",
  },
  confirmTel: {
    de: "Telefonnummer bestätigen",
    it: "Conferma numero",
    en: "Confirm number",
  },
  confirmTelInvite: {
    de: "Bestätige jetzt deine Telefonnummer.",
    it: "Conferma ora il tuo numero di telefono.",
    en: "Confirm your phone number now.",
  },
  confirmTelInfoCode: {
    de: "Wir haben dir eine SMS mit einem Code gesendet. Gib ihn unten ein, um deine Nummer zu bestätigen.",
    it: "Ti abbiamo inviato un SMS con un codice. Inseriscilo qui sotto per verificare il tuo numero.",
    en: "We sent you an SMS with a code. Enter it below to verify your number.",
  },
  pwForgotMail: {
    de: "Du hast einen Code per E-Mail erhalten, bitte tippe ihn hier ein!",
    it: "Hai ricevuto un codice via e-mail, inseriscilo qui!",
    en: "You have received a code via email, please enter it here!",
  },
  codeInvalid: {
    de: "Der eingegebene Code ist ungültig!",
    it: "Il codice inserito non è valido!",
    en: "The entered code is invalid!",
  },
  submit: {
    de: "Absenden",
    it: "Invia",
    en: "Submit",
  },
  code: {
    de: "Bestätigungscode",
    it: "Codice di conferma",
    en: "Confirmation code",
  },
  premiumPrice: {
    de: "14,99 € im Jahr",
    it: "14,99 € al anno",
    en: "14,99 € per year",
  },
  getPremium: {
    de: "Jetzt Premium Account sichern!",
    it: "Assicurati la versione Premium!",
    en: "Get your Premium Account!",
  },
  insiderCont: {
    de: "Als Insider kannst du die Spiele, Resultate und Aufstellungen deiner Mannschaft verwalten.",
    it: "Come Insider, puoi gestire le partite, i risultati e le formazioni della tua squadra.",
    en: "As an Insider, you can manage your team's games, results and lineups.",
  },
  moreInfo: {
    de: "Erfahre mehr",
    it: "Scopri di più",
    en: "More info",
  },
  beInsiderNow: {
    de: "Jetzt Insider werden",
    it: "Diventa Insider",
    en: "Become an Insider",
  },
  insiderRequestInfo: {
    de: "Der Antrag wird an den jeweiligen Vereinsmanager gestellt. Dieser ist für den gesamten Verein zuständig. Er hat das Recht Insider und andere Vereinsmanager hinzuzufügen und zu entfernen.",
    it: "La domanda va presentata al rispettivo club manager. È responsabile dell'intero club. Ha il diritto di aggiungere e rimuovere Insider e altri club manager.",
    en: "The application is submitted to the respective club manager. He is responsible for the whole club. He has the right to add and remove Insiders and other club managers.",
  },
  createNew: {
    de: "Neu erstellen",
    it: "Crea nuovo",
    en: "Create new",
  },
  premiumAccount: {
    de: "Premium Account",
    it: "Premium Account",
    en: "Premium Account",
  },
  noMatchforSearch: {
    de: "Nichts gefunden",
    it: "Nichts gefunden",
    en: "Nichts gefunden",
  },
  changeTeamThumb: {
    de: "Mannschaftsfoto ändern",
    it: "Cambia foto",
    en: "Change foto",
  },
  earlier: {
    de: "Früher",
    it: "Prima",
    en: "Earlier",
  },
  later: {
    de: "Später",
    it: "Dopo",
    en: "Later",
  },
  today: {
    de: "Heute",
    it: "Oggi",
    en: "Today",
  },
  tomorrow: {
    de: "Morgen",
    it: "Domani",
    en: "Tomorrow",
  },
  yesterday: {
    de: "Gestern",
    it: "Ieri",
    en: "Yesterday",
  },
  featuredNews: {
    de: "Featured News",
    it: "Featured News",
    en: "Featured News",
  },
  modifySponsor: {
    de: "Sponsor bearbeiten",
    it: "Modifica sponsor",
    en: "Edit sponsor",
  },
  addSponsor: {
    de: "Hinzufügen",
    it: "Aggiungi",
    en: "Add",
  },
  insertMatch: {
    de: "Spiel eintragen",
    it: "Inserisci partita",
    en: "Insert match",
  },
  doTransfer: {
    de: "Transfer eintragen",
    it: "Effettuare trasferimenti",
    en: "Make a transfer",
  },
  editSquad: {
    de: "Kader bearbeiten",
    it: "Modifica rosa",
    en: "Modify team",
  },
  save: {
    de: "Speichern",
    it: "Salva",
    en: "Save",
  },
  voteMotmNow: {
    de: "Man of the Match wählen",
    it: "Vota il Man of the Match",
    en: "Vote the Man of the Match",
  },
  voteMotm: {
    de: "MAN OF THE MATCH WÄHLEN",
    it: "VOTA IL MAN OF THE MATCH",
    en: "VOTE MAN OF THE MATCH",
  },
  voteNow: {
    de: "Jetzt wählen!",
    it: "Vota ora!",
    en: "Vote now!",
  },
  infoVoteMotm: {
    de: "Der Man of the Match wird von den Usern auf Basis seiner Leistung gewählt. Nur die drei Erstplatzierten nach Stimmen werden angezeigt.",
    it: "Il Man of the Match viene scelto dagli utenti in base alla sua prestazione. Vengono visualizzati solo i primi tre per voti.",
    en: "The Man of the Match is chosen by the users based on his performance. Only the top three by votes are displayed.",
  },
  toFewVotes: {
    de: "Zu wenig Stimmen",
    it: "Troppo pochi voti",
    en: "To few votes",
  },
  choosePlayer: {
    de: "Spieler wählen",
    it: "Seleziona giocatore",
    en: "Choose player",
  },
  chooseAssist: {
    de: "Assist wählen",
    it: "Seleziona giocatore",
    en: "Choose player",
  },
  whoComesOut: {
    de: "Wer wird ausgewechselt?",
    it: "Chi esce?",
    en: "Who will be substituted (OUT)?",
  },
  whoComesIn: {
    de: "Wer wird eingewechselt?",
    it: "Chi entra?",
    en: "Who will be substituted (IN)?",
  },
  scorer: {
    de: "Torschütze",
    it: "Marcatore",
    en: "Scorer",
  },
  injured: {
    de: "Verletzung",
    it: "Lesione",
    en: "Injury",
  },
  assist: {
    de: "Assist",
    it: "Assist",
    en: "Assist",
  },
  player: {
    de: "Spieler",
    it: "Giocatore",
    en: "Player",
  },
  topScorerTitle: {
    de: "Bester Torschütze",
    it: "Miglior marcatore",
    en: "Top scorer",
  },
  squadNotAvailable: {
    de: "Kader nicht verfügbar",
    it: "Rosa non disponibile",
    en: "Squad not available",
  },
  forWord: {
    de: "für",
    it: "per",
    en: "for",
  },
  wrongdoer: {
    de: "Übeltäter",
    it: "Giocatore",
    en: "Wrongdoer",
  },
  newTeam: {
    de: "Neue Mannschaft",
    it: "Nuova squadra",
    en: "New team",
  },
  oldTeam: {
    de: "Aus Team",
    it: "Aus Team",
    en: "Aus Team",
  },
  chooseLeague: {
    de: "Liga wählen",
    it: "Seleziona campionato",
    en: "Choose league",
  },
  chooseTeam: {
    de: "Mannschaft wählen",
    it: "Seleziona squadra",
    en: "Choose team",
  },
  transferIn: {
    de: "Neuzugang",
    it: "Arrivo",
    en: "Arrival",
  },
  transferOut: {
    de: "Abgang",
    it: "Partenza",
    en: "Departure",
  },
  resetPw: {
    de: "Passwort zurücksetzen",
    it: "Resetta la password",
    en: "Reset password",
  },
  pwForgot: {
    de: "Passwort vergessen?",
    it: "Dimenticato password?",
    en: "Forgot password?",
  },
  pwForgotCodeSent: {
    de: "Wir haben einen Code an {identifier} gesendet. Bitte gib ihn hier ein:",
    it: "Abbiamo inviato un codice a {identifier}. Inseriscilo qui:",
    en: "We sent a code to {identifier}. Please enter it here:",
  },
  pwForgotNewPassword: {
    de: "Bitte wähle ein neues Passwort:",
    it: "Scegli una nuova password:",
    en: "Please choose a new password:",
  },
  newPassword: {
    de: "Neues Passwort",
    it: "Nuova password",
    en: "New password",
  },
  repeatPassword: {
    de: "Passwort wiederholen",
    it: "Ripeti password",
    en: "Repeat password",
  },
  pwMinLength: {
    de: "Das Passwort muss mindestens 8 Zeichen lang sein",
    it: "La password deve essere di almeno 8 caratteri",
    en: "Password must be at least 8 characters long",
  },
  resetting: {
    de: "Wird zurückgesetzt...",
    it: "Reimpostazione in corso...",
    en: "Resetting...",
  },
  resetPassword: {
    de: "Passwort zurücksetzen",
    it: "Reimposta password",
    en: "Reset password",
  },
  mailOrTel: {
    de: "E-Mail Adresse oder Telefonnummer",
    it: "Indirizzo e-mail o Numero di telefono",
    en: "Email address or telephone number",
  },

  telIdentifier: {
    de: "Telefonnummer",
    it: "Numero di telefono",
    en: "Telephone number",
  },
  loginViaSms: {
    de: "Anmeldung via SMS",
    it: "Accedi tramite SMS",
    en: "Login via SMS",
  },
  recaptchaNoticeStart: {
    de: "Diese Seite ist durch reCAPTCHA geschützt und es gelten die Google",
    it: "Questo sito è protetto da reCAPTCHA. Si applicano le seguenti policy di Google:",
    en: "This site is protected by reCAPTCHA and the Google",
  },
  recaptchaNoticeAnd: {
    de: " und die ",
    it: " e ",
    en: " and ",
  },
  recaptchaNoticeEnd: {
    de: " gelten.",
    it: ".",
    en: " apply.",
  },
  linkViaSmsAndMail: {
    de: "Befolge die Anweisungen in der E-Mail/SMS die du bekommen hast um dich anzumelden.",
    it: "Segui le istruzioni contenute nell'e-mail/SMS che hai ricevuto per accedere.",
    en: "Follow the instructions in the email/SMS you received to log in.",
  },
  enterEvent: {
    de: "Ereignis eintragen",
    it: "Inserire evento",
    en: "Enter event",
  },
  editMatch: {
    de: "Spiel verwalten",
    it: "Modifica partita",
    en: "Edit game",
  },
  cancelMatch: {
    de: "Spiel absagen",
    it: "Annula la partita",
    en: "Cancel game",
  },
  matchTime: {
    de: "Datum & Uhrzeit",
    it: "Data & orario",
    en: "Date & Time",
  },
  changeMatchTime: {
    de: "Datum & Uhrzeit ändern",
    it: "Cambia data & orario",
    en: "Change date & time",
  },
  changeMatchLocation: {
    de: "Spielstätte ändern",
    it: "Cambia luogo",
    en: "Change field",
  },
  successGroupRequest: {
    de: "Deine Anfrage wurde versendet. Du siehst deine laufenden Anfragen hier!",
    it: "La tua richiesta è stata inviata. Puoi vedere le tue richieste in corso qui!",
    en: "Your request has been sent. You can see your ongoing requests here!",
  },
  gameMinute: {
    de: "Spielminute",
    it: "Minuto",
    en: "Minute",
  },
  goal: {
    de: "Tor",
    it: "Gol",
    en: "Goal",
  },
  chance: {
    de: "Chance",
    it: "Occasione",
    en: "Chance",
  },
  whatHappened: {
    de: "Was ist passiert?",
    it: "Che cosa è successo?",
    en: "What happened?",
  },
  card: {
    de: "Karte",
    it: "Cartellino",
    en: "Card",
  },
  change: {
    de: "Wechsel",
    it: "Cambio",
    en: "Change",
  },
  cancel: {
    de: "Abbrechen",
    it: "Annulla",
    en: "Cancel",
  },
  selectDate: {
    de: "Datum wählen",
    it: "Seleziona data",
    en: "Choose date",
  },
  tel: {
    de: "Telefon",
    it: "Telefono",
    en: "Phone",
  },
  message: {
    de: "Nachricht",
    it: "Messagio",
    en: "Message",
  },
  requests: {
    de: "Anträge",
    it: "Richieste",
    en: "Requests",
  },
  infoRequests: {
    de: "Jeder kann einen Antrag stellen um Insider zu werden. Bitte überprüfe genau wem du diese Rolle zuweist",
    it: "Chiunque può candidarsi per diventare un insider. Controlla attentamente a chi assegni questo ruolo",
    en: "Anyone can apply to become an insider. Please check carefully who you assign this role to",
  },
  request: {
    de: "Antrag",
    it: "Richiesta",
    en: "Request",
  },
  accept: {
    de: "Annehmen",
    it: "Accettare",
    en: "Accept",
  },
  decline: {
    de: "Ablehnen",
    it: "Declinare",
    en: "Decline",
  },
  noOtherInsiders: {
    de: "Keine anderen Vereinsmanager oder Insider",
    it: "Nessun altro club manager o insider",
    en: "No other club managers or insiders",
  },
  infoTeamInsider: {
    de: "Der Vereinsmanager kann nicht nur Ergebnisse, Ereignisse und Aufstellungen eintragen, sondern ist auch dazu befugt Vereinsdaten, Mannschaftsbilder und weitere Details zu ändern sowie Transfers zu tätigen. Sei also vorsichtig, wenn du zum Vereinsmanager ernennst!",
    it: "Il club manager non può solo inserire risultati, eventi e formazioni, ma è anche autorizzato a modificare il profilo del club, le foto della squadra e ad effettuare trasferimenti. Quindi fai attenzione quando nominerai un manager di club!",
    en: "The club manager can not only enter results, events and line-ups, but is also authorized to change the club data, team pictures and to make transfers. So be careful when you appoint as a club manager!",
  },
  infoInsider: {
    de: "Insider können Ergebnisse, Ereignisse und Aufstellungen für alle Mannschaften deines Vereins eintragen sowie Spiele absagen oder verschieben.",
    it: "Gli Insider possono pubblicare risultati, eventi e formazioni per tutte le squadre del tuo club, nonché annullare o riprogrammare le partite.",
    en: "Insiders can post results, events and line-ups for all teams in your club, as well as cancel or reschedule games.",
  },
  infoTel: {
    de: "Die Telefonnummer kann vom Vereinsmanger eingesehen werden, um in direkten Kontakt mit dir zu treten",
    it: "Il numero di telefono può essere visto dal manager del club per mettersi in contatto diretto con te",
    en: "The phone number can be seen by the club manager to get in direct contact with you",
  },
  infoMessage: {
    de: "Begründe warum du Ergebnisse für diese Mannschaft eintragen möchtest.",
    it: "Spiega perché vuoi inserire i risultati per questa squadra.",
    en: "Justify why you want to enter results for this team.",
  },
  info: {
    de: "Hinweis",
    it: "Avviso",
    en: "Notice",
  },
  teamRanking: {
    de: "Team Statistiken",
    it: "Team Rankings",
    en: "Team Rankings",
  },
  playerRanking: {
    de: "Spieler Statistiken",
    it: "Player Rankings",
    en: "Player Rankings",
  },
  tow: {
    de: "Team of the Week",
    it: "Team of the Week",
    en: "Team of the Week",
  },
  noPosition: {
    de: "Keine Position zugewiesen!",
    it: "Nessuna posizione assegnata!",
    en: "No position assigned!",
  },
  chooseFavoriteTeam: {
    de: "Wähle deine Lieblingsmannschaften",
    it: "Seleziona le tue squadre preferite",
    en: "Choose your favourite teams",
  },
  needCamPermission: {
    de: "Kamera Zugriff",
    it: "Accesso alla telecamera",
    en: "Camera access",
  },
  needCamPermissionCont: {
    de: "Wir benötigen die Berechtigung, um auf die Kamera zuzugreifen!",
    it: "Abbiamo bisogno del permesso per accedere alla fotocamera!",
    en: "We need permission to access the camera!!",
  },
  grantPermission: {
    de: "Erlauben",
    it: "Permettere",
    en: "Allow",
  },
  upload: {
    de: "Upload",
    it: "Upload",
    en: "Upload",
  },
  addNewTitle: {
    de: "Titel hinzufügen",
    it: "Aggiungi titolo",
    en: "Add title",
  },
  addNewLocation: {
    de: "Spielstätte hinzufügen",
    it: "Aggiungi luogo",
    en: "Add location",
  },
  addNewLocationInfo: {
    de: "In diesem Feld kannst du nach einem neuen Spielort suchen",
    it: "In questo campo puoi cercare una nuova posizione di gioco",
    en: "In this field you can search for a new game location",
  },
  jersey: {
    de: "Trikotnummer",
    it: "Numero maglia",
    en: "Number jersey",
  },
  sponsorName: {
    de: "Name",
    it: "Nome",
    en: "Name",
  },
  sponsorLink: {
    de: "Link",
    it: "Link",
    en: "Link",
  },
  deleteSponsor: {
    de: "Löschen",
    it: "Elimina",
    en: "Delete",
  },
  noSponsors: {
    de: "Keine Sponsoren",
    it: "Nessuno sponsor",
    en: "No sponsors",
  },
  noLogo: {
    de: "Kein Logo",
    it: "Nessun logo",
    en: "No logo",
  },
  sponsors: {
    de: "Sponsoren",
    it: "Sponsor",
    en: "Sponsors",
  },
  changeImage: {
    de: "Bild ändern",
    it: "Cambia foto",
    en: "Change image",
  },
  profile: {
    de: "Profil",
    it: "Profilo",
    en: "Profile",
  },
  myLeagues: {
    de: "Favoriten",
    it: "Favoriti",
    en: "Favorites",
  },
  news: {
    de: "News",
    it: "Notizie",
    en: "News",
  },
  learnMore: {
    de: "Mehr erfahren",
    it: "Scopri di più",
    en: "Learn more",
  },
  search: {
    de: "Suche",
    it: "Ricerca",
    en: "Search",
  },
  resultsFor: {
    de: "Ergebnisse für \"[query]\"",
    it: "Risultati per \"[query]\"",
    en: "Results for \"[query]\"",
  },
  noResults: {
    de: "Keine Ergebnisse gefunden",
    it: "Nessun risultato trovato",
    en: "No results found",
  },
  more: {
    de: "Mehr",
    it: "Altro",
    en: "More",
  },
  playerInfoAppOnly: {
    de: "Um detaillierte Spielerinformationen zu sehen, lade die Clava App auf dein Smartphone herunter.",
    it: "Per vedere le informazioni dettagliate sui giocatori, scarica l'app Clava sul tuo smartphone.",
    en: "To see detailed player information, download the Clava app on your smartphone.",
  },
  reorder: {
    de: "Neu Anordnen",
    it: "Riorganizzare",
    en: "Rearrange",
  },
  allLeagues: {
    de: "Alle Ligen",
    it: "Tutti i campionati",
    en: "All leagues",
  },
  MatchHistory: {
    de: "Spielverlauf",
    it: "Riassunto",
    en: "Summary",
  },
  MatchLineup: {
    de: "Aufstellung",
    it: "Rosa",
    en: "Lineup",
  },
  MatchInfo: {
    de: "Info",
    it: "Info",
    en: "Info",
  },
  yourBet: {
    de: "Dein Tipp?",
    it: "Il tuo pronostico?",
    en: "Your Bet?",
  },
  MatchStatistics: {
    de: "Statistiken",
    it: "Statistiche",
    en: "Statistics",
  },
  MatchMotm: {
    de: "Man of the Match",
    it: "Man of the Match",
    en: "Man of the Match",
  },
  TeamInfo: {
    de: "Info",
    it: "Info",
    en: "Info",
  },
  TeamMatches: {
    de: "Spiele",
    it: "Partite",
    en: "Matches",
  },
  TeamTable: {
    de: "Tabelle",
    it: "Classifica",
    en: "Table",
  },
  TeamSquad: {
    de: "Kader",
    it: "Squadra",
    en: "Squad",
  },
  TeamStatistics: {
    de: "Statistiken",
    it: "Statistiche",
    en: "Stats",
  },
  errorMailSubject: {
    de: "Fehler beim Spiel [id]",
    it: "Errore partita [id]",
    en: "Error in game [id]",
  },
  errorMailBody: {
    de: "Fehlerbeschreibung:\n\n\ngemeldet von [user_id]",
    it: "Descrizione errore:\n\n\ngemeldet von [user_id]",
    en: "Description error:\n\n\ngemeldet von [user_id]",
  },
  newVersion: {
    de: "Neue App Version",
    it: "Nuova versione dell'app",
    en: "New app version",
  },
  newVersionRequired: {
    de: "App Version veraltet",
    it: "È richiesta una nuova versione dell'app",
    en: "New app version required",
  },
  newVersionBody: {
    de: "Hurra, wir haben neue Features für dich! Bitte aktualisiere deine App, um alle Neuheiten zu sehen.",
    it: "Evviva, abbiamo nuove funzionalità per te! Aggiorna la tua app per vedere le novità.",
    en: "Hooray, we have new features for you! Please update your app to see what's new",
  },
  newVersionRequiredBody: {
    de: "Deine App Version ist veraltet, einige Sachen könnten nicht mehr funktionieren. Bitte aktualisiere die App!",
    it: "La versione dell'app non è aggiornata, alcune cose potrebbero non funzionare più. Si prega di aggiornare l'app!",
    en: "Your app version is out of date, some things may not work anymore. Please update the app!",
  },
  update: {
    de: "Jetzt updaten",
    it: "Aggiorna ora",
    en: "Update now",
  },
  loadingLeagues: {
    de: "Lade Ligen",
    it: "Carica campionati",
    en: "Load leagues",
  },
  changedIn: {
    de: "Eingewechselt",
    it: "Entra",
    en: "Sub IN",
  },
  changedOut: {
    de: "Ausgewechselt",
    it: "Esce",
    en: "Sub OUT",
  },
  assists: {
    de: "Assists",
    it: "Assist",
    en: "Assist",
  },
  evaluation: {
    de: "Bewertung",
    it: "Valutazione",
    en: "Evaluation",
  },
  tryClavaPro: {
    de: "Probiere CLAVA PRO aus, um auf mehr Statistiken zuzugreifen",
    it: "Prova CLAVA PRO per accedere a più statistiche",
    en: "Try CLAVA PRO to access more statistics",
  },
  mostAssists: {
    de: "Meiste Assists",
    it: "Più assist",
    en: "Most assists",
  },
  mostYellowCards: {
    de: "Meiste gelbe Karten",
    it: "Più cartellini gialli",
    en: "Most yellow cards",
  },
  mostRedCards: {
    de: "Meiste rote Karten",
    it: "Più cartellini rossi",
    en: "Most red cards",
  },
  mostTotwAwards: {
    de: "Meiste TOTW-Auszeichnungen",
    it: "Più premi TOTW",
    en: "Most TOTW-Awards",
  },
  mostMotmAwards: {
    de: "Meiste MOTM-Auszeichnungen",
    it: "Più premi MOTM",
    en: "Most MOTM Awards",
  },
  mostMinutes: {
    de: "Meiste Minuten",
    it: "Più minuti",
    en: "Most Minutes",
  },
  playedMinutes: {
    de: "Gespielte Minuten",
    it: "Minuti giocati",
    en: "Minutes played",
  },
  back: {
    de: "Zurück",
    it: "Indietro",
    en: "Back",
  },
  shapeComparison: {
    de: "Formvergleich",
    it: "Confronto forma",
    en: "Shape comparison",
  },
  // De 3 sein fürn Formvergleich, tauscht do di buachstobn aus wias enk passt
  win: {
    de: "S", // Sieg
    it: "V", // Vinto
    en: "W", // Win
  },
  draw: {
    de: "U", // Unentschieden
    it: "N", // Nulle
    en: "D", // Draw
  },
  loss: {
    de: "N", // Niederlage
    it: "P", // Perso
    en: "L", // Loss
  },
  season: {
    de: "Saison",
    it: "Stagione",
    en: "Season",
  },
  seasonOverview: {
    de: "Saison im Überblick",
    it: "Overview della stagione",
    en: "Season overview",
  },
  goalDistribution: {
    de: "Zeitpunkt der Tore",
    it: "Minuti dei gol",
    en: "Time of goals",
  },
  goalDistributionInfo: {
    de: "Zeitpunkt der Tore, in welcher die Mannschaft statistisch gesehen die Tore schießt.", // Mari, Ivan, des verändert sich nimmer sobold is match vorbei isch, also de statistik isch über di leschtn X matches vo den match aus gsechn, kannt man do villeicht eini schreibn.
    it: "Tempistica dei goal in cui la squadra segna statisticamente i goal.", // PS: olles wos noch den '//' steat isch a kommentar und werd im code ignoriert, also wenn es des gemocht hop kennt es den kommentar a löschen, i hon sischt a oftramol no a poor kommentare stian
    en: "Timing of the goals at which the team statistically scores the goals.",
  },
  playerInFocus: {
    de: "Spieler im Fokus",
    it: "Giocatori in forma",
    en: "Player in focus",
  },
  playerInFocusInfo: {
    de: "Spieler, die in den letzten Spielen am meisten Stimmen bei der Wahl zum Man of the Match erhalten haben.",
    it: "I giocatori che hanno ricevuto il maggior numero di voti Man of the Match nelle ultime partite.",
    en: "Players who have received the most Man of the Match votes in recent games.",
  },
  tablePos: {
    de: "#",
    it: "#",
    en: "#",
  },
  pointsExt: {
    de: "Punkte",
    it: "Punti",
    en: "Poins",
  },
  winsExt: {
    de: "Siege",
    it: "Vittorie",
    en: "Wins",
  },
  lossesExt: {
    de: "Niederlagen",
    it: "Sconfitte",
    en: "Defeats",
  },
  drawsExt: {
    de: "Unentschieden",
    it: "Pareggi",
    en: "Draws",
  },
  goalsOutExt: {
    de: "Ø Tore",
    it: "Ø Gol",
    en: "Ø Goal",
  },
  goalsInExt: {
    de: "Ø Gegentore",
    it: "Ø gol subiti",
    en: "Ø Gegentore",
  },
  sixth1: {
    de: "0' - 15'",
    it: "0' - 15'",
    en: "0' - 15'",
  },
  sixth2: {
    de: "16' - 30'",
    it: "16' - 30'",
    en: "16' - 30'",
  },
  sixth3: {
    de: "31' - 45'",
    it: "31' - 45'",
    en: "31' - 45'",
  },
  sixth4: {
    de: "46' - 60'",
    it: "46' - 60'",
    en: "46' - 60'",
  },
  sixth5: {
    de: "61' - 75'",
    it: "61' - 75'",
    en: "61' - 75'",
  },
  sixth6: {
    de: "76' - 90'",
    it: "76' - 90'",
    en: "76' - 90'",
  },
  history: {
    de: "Historie",
    it: "Storia",
    en: "History",
  },
  chooseOrTake: {
    de: "Bild hochladen",
    it: "Carica immagine",
    en: "Upload photo",
  },
  chooseOrTakeCont: {
    de: "Foto machen oder aus der Gallerie auswählen? Achtung: die Bilder werden im Format [format] zugeschnitten.",
    it: "Scattare una foto o scegliere dalla galleria? Attenzione: le immagini vengono ritagliate in formato [format].",
    en: "Take a photo or choose from the gallery? Attention: the images are cropped in format [format].",
  },
  takePicture: {
    de: "Kamera öffnen",
    it: "Apri camera",
    en: "Take picture",
  },
  choosePicture: {
    de: "Gallerie öffnen",
    it: "Apri galleria",
    en: "Choose picture",
  },
  rotateForMore: {
    de: "Handy drehen für mehr Infos",
    it: "Ruota per più info",
    en: "Rotate for more",
  },
  Transfers: {
    de: "Transfers",
    it: "Trasferimenti",
    en: "Transfers",
  },
  noNews: {
    de: "Noch keine News",
    it: "Ancora nessuna notizia",
    en: "No news yet - coming soon",
  },
  noTransen: {
    de: "Noch keine Transfers",
    it: "Ancora nessun trasferimento",
    en: "No transfers - coming soon",
  },
  noVideos: {
    de: "Noch keine Videos - coming soon",
    it: "Ancora nessun video - coming soon",
    en: "No vidoes yet - coming soon",
  },
  viewExtern: {
    de: "Weiterlesen",
    it: "Continua",
    en: "Learn more",
  },
  matchNotStarted: {
    de: "Das Spiel hat noch nicht begonnen!",
    it: "Partita non ancora iniziata!",
    en: "Match not started yet!",
  },
  sureCancelMatch: {
    de: "Bist du sicher dass du das Spiel absagen möchtest?",
    it: "Sei sicuro di cancellare la partita?",
    en: "Are you sure you want to cancel the game?",
  },
  yes: {
    de: "Ja",
    it: "Si",
    en: "Yes",
  },
  no: {
    de: "Nein",
    it: "No",
    en: "No",
  },
  canceled: {
    de: "Abgesagt",
    it: "Cancellato",
    en: "Canceled",
  },
  deleteAccount: {
    de: "Account löschen?",
    it: "Cancellare l'account?",
    en: "Delete account?",
  },
  deleteAccountCont: {
    de: "Bist du sicher dass du deinen Account mit allen deinen Daten löschen möchtest?",
    it: "Sei sicuro di voler cancellare il tuo account con tutti i tuoi dati?",
    en: "Are you sure you want to delete your account with all your data?",
  },
  versionNews: {
    de: "Neu in dieser Version",
    it: "Nuovo in questa versione",
    en: "New in this version",
  },
  versionNewsBody: {
    de:
      "v0.9.93:\n" +
      "Neu:\n" +
      "- Vereinsmanager sehen nun in der Navigationsleiste ob es neue Insider-Anfragen gibt\n" +
      "\n" +
      "Bugfix:\n" +
      "- Fehler in der Transfer-Ansicht wurden behoben\n" +
      "- Fehler behoben bei Mannschaftsinfo / Sponsoren bearbeiten\n" +
      "- On-screen keyboard hat Daten verdeckt \n" +
      '- Manchmal waren falsche Fehlermeldungen sichtbar (z.b. "Bitte kontrolliere deine Verbindung zum Internet!")\n' +
      "- Navigations-fehler behoben\n" +
      "- Fehler behoben bei der Verwaltung der Spieler\n" +
      "- Fehler behoben das die Posizion transferierter Spieler nicht mehr verändert werden konnte\n" +
      "\n" +
      "v0.9.92\n" +
      "Bugfix:\n" +
      "- Spielernamen konnten nicht verändert werden\n" +
      "- Deep-Links\n",
    it:
      "v0.9.93:\n" +
      "Nuovo:\n" +
      "- I manager del club ora possono vedere nella barra di navigazione se ci sono nuove richieste di Insider\n" +
      "\n" +
      "Bugifx:\n" +
      "- I bug nella vista di trasferimento sono stati corretti\n" +
      "- Risolti errori durante la modifica delle informazioni sulla squadra e degli sponsor\n" +
      "- Risolto bug con la tastiera su schermo\n" +
      '- Sono stati corretti messaggi errati (ad es. "Verifica la tua connessione a Internet!")\n' +
      "- Risolti bug di navigazione\n" +
      "- Sono stati corretti gli errori di gestione dei giocatori\n" +
      "\n" +
      "v0.9.92\n" +
      "Bugfix:\n" +
      "- Ora si può cambiare il nome dei giocatori\n" +
      "- Deep-Links",
    en:
      "v0.9.93:\n" +
      "New: \n" +
      "- Team manager see in the Bottom bar if they got any new insider requests\n" +
      "\n" +
      "Bugfix:\n" +
      "- Bug fixed in the Transfer-view\n" +
      "- Bugs fixed in the Teaminfo view\n" +
      "- On-screen keyboard has hidden some data\n" +
      '- Sometimes wrong error messages were displayed (f.e. "Please check your connection to the internet!")\n' +
      "- Navigation-Bugfix\n" +
      "- Bugs fixed that occured during managing players\n" +
      "\n" +
      "v0.9.92:\n" +
      "Bugfix:\n" +
      "- Player name could not be changed\n" +
      "- Deep-Links",
  },
  awesome: {
    de: "Hurra!",
    it: "Grande!",
    en: "Awesome!",
  },
  CreateNews: {
    de: "Beitrag erstellen",
    it: "Crea una notizia",
    en: "Create new blog news",
  },
  deu: {
    de: "DEU",
    it: "TED",
    en: "GER",
  },
  ita: {
    de: "ITA",
    it: "ITA",
    en: "ITA",
  },
  eng: {
    de: "ENG",
    it: "ING",
    en: "ENG",
  },
  title: {
    de: "Titel",
    it: "Titolo",
    en: "Title",
  },
  link: {
    de: "Link",
    it: "Link",
    en: "Redirect link",
  },
  body: {
    de: "Haupttext",
    it: "Body",
    en: "Body",
  },
  preview: {
    de: "Vorschau",
    it: "Preview",
    en: "Preview",
  },
  choosePosition: {
    de: "Posizion wählen",
    it: "Seleziona posizione",
    en: "Select position",
  },
  upTo3Players: {
    de: "Wähle bis zu 3 Spieler",
    it: "Puoi selezionare 3 giocatori",
    en: "Vote 3 players",
  },
  canVote3: {
    de: "Noch [num] Spieler wählen",
    it: "Vota ancora [num]",
    en: "Vote another [num]",
  },
  matchStartsShortly: {
    de: "Das Spiel startet in Kürze",
    it: "La partita inizierà tra poco",
    en: "The match starts soon",
  },
  motmAfter80Min: {
    de: "Der Man of the Match kann erst am Ende des Spiels gewählt werden.",
    it: "Il Man of the Match può essere votato solo a fine partita.",
    en: "Man of the Match can be voted at the end of the match.",
  },
  noTowForMatchday: {
    de: "Noch kein Team of the Week für diesen Spieltag",
    it: "Ancora nessun Team of the Week per questa giornata",
    en: "",
  },
  optional: {
    de: "(optional)",
    it: "(optional)",
    en: "(optional)",
  },
  chooseScorerInfo: {
    de: "Falls eine Aufstellung eingetragen wurde, werden nur die Spieler auf dem Platz angzeigt. Anderenfalls der gesamte Kader.",
    it: "Se è stata inserita una formazione, vengono mostrati solo i giocatori in campo. Altrimenti tutta la rosa.",
    en: "If the line-up has been entered, only the players on the pitch are displayed, otherwise the whole squad.",
  },
  becomeInsider: {
    de: "Werde Insider",
    it: "Diventa Insider",
    en: "Become an Insider",
  },
  onlyLetters: {
    de: "Nur Buchstaben und Leerzeichen",
    it: "Solo lettere e spazi",
    en: "Nur Buchstaben und Leerzeichen",
  },
  deleteEvent: {
    de: "Löschen",
    it: "Elimina",
    en: "Delete event",
  },
  sureWantDelete: {
    de: "Bist du sicher dass du [title] löschen möchten?", // Konn man laar lossn
    it: "Bist du sicher dass du [title] löschen möchten?",
    en: "Bist du sicher dass du [title] löschen möchten?",
  },
  sureWantDeleteCARD: {
    de: "Bist du sicher, dass du diese Karte löschen möchtest?",
    it: "Sei sicuro di cancellare il cartellino?",
    en: "Are you sure to delete this card?",
  },
  sureWantDeleteGOAL: {
    de: "Bist du sicher, dass du dieses Tor löschen möchtest?",
    it: "Sei sicuro di cancellare il gol?",
    en: "Are you sure to delete this goal?",
  },
  sureWantDeleteCHANGE: {
    de: "Bist du sicher, dass du den Wechsel löschen möchtest?",
    it: "Sei sicuro di cancellare il cambio?",
    en: "Are you sure to delete this change?",
  },
  sureWantDeleteCHANCE: {
    de: "Bist du sicher, dass du diese Chance löschen möchtest?",
    it: "Sei sicuro di cancellare l'occasione?",
    en: "Are you sure to delete this opportunity?",
  },
  hideFuture: {
    de: "Nicht mehr nachfragen!",
    it: "Non chiedere più!",
    en: "Want to hide this message in the future!",
  },
  now: {
    de: "Jetzt!",
    it: "Adesso!",
    en: "Now!",
  },
  startBefore: {
    de: "Vor [min] Min.",
    it: "[min] min. fa",
    en: "[min] min ago",
  },
  startAfter: {
    de: "In [min] Min.",
    it: "Tra [min] min.",
    en: "In [min] min.",
  },
  startMatch: {
    de: "Anpfiff!",
    it: "Calcio d'inizio!",
    en: "Kick-off!",
  },
  LEAGUE: {
    de: "Meisterschaften",
    it: "Campionati",
    en: "Leagues",
  },
  CUP: {
    de: "Pokal",
    it: "Coppa",
    en: "Pokal",
  },
  YOUTH: {
    de: "Jugend",
    it: "Giovanili",
    en: "Youth",
  },
  VSS_YOUTH: {
    de: "VSS - Jugend",
    it: "VSS - Giovanili",
    en: "VSS - Youth",
  },
  VSS_FREE_TIME: {
    de: "VSS - Freizeit",
    it: "VSS - Tempo libero",
    en: "VSS - Recreational",
  },
  VIENNA: {
    de: "Wien",
    it: "Vienna",
    en: "Vienna",
  },
  WOMEN: {
    de: "Frauen",
    it: "Femminile",
    en: "Women",
  },
  statsSoonAvailable: {
    de: "Bald verfügbar",
    it: "Disponibile a breve",
    en: "Available soon",
  },
  highlights: {
    de: "Highlights",
    it: "Highlights",
    en: "Highlights",
  },
  highlightsScoreTitle: {
    de: "Endgültiges Resultat",
    it: "Risultato finale",
    en: "Final score",
  },
  hideTeam: {
    de: "[team] ausblenden",
    it: "Nascondi [team]",
    en: "Hide [team]",
  },
  format: {
    de: "Format",
    it: "Formato",
    en: "Format",
  },
  showDetail: {
    de: "Detailierte Ansicht",
    it: "Visto dettaglio",
    en: "Detailed view",
  },
  minimize: {
    de: "Verkleinern",
    it: "Minimare",
    en: "Minimize",
  },
  youWantBeInsider: {
    de: "Möchtest du Ergebnisse eintragen?",
    it: "Vuoi inserire eventi (gol, formazioni, ecc.)?",
    en: "Do you want to enter Events?",
  },
  users: {
    de: "Benutzer",
    it: "Utenti",
    en: "Users",
  },
  ads: {
    de: "Werbung",
    it: "Pubblicitá",
    en: "Ads",
  },
  administration: {
    de: "Administrazion",
    it: "Administrazione",
    en: "Administration",
  },
  adminpanel: {
    de: "Backoffice",
    it: "Backoffice",
    en: "Backoffice",
  },
  yourNotAdmin: {
    de: "Nur für Admins Sichtbar. Bitte als Admin anmelden!",
    it: "Nur für Admins Sichtbar. Bitte als Admin anmelden!",
    en: "Nur für Admins Sichtbar. Bitte als Admin anmelden!",
  },
  createVideo: {
    de: "Video Erstellen",
    it: "Crea Video",
    en: "Create Video",
  },
  length: {
    de: "Länge",
    it: "Lunghezza",
    en: "Length",
  },
  url: {
    de: "Link",
    it: "Link",
    en: "Link",
  },
  date: {
    de: "Datum",
    it: "Datum",
    en: "Datum",
  },
  searchLeagueExpl: {
    de: "Liga Suchen (Name oder Liga ID)",
    it: "Liga Suchen (Name oder Liga ID)",
    en: "Liga Suchen (Name oder Liga ID)",
  },
  searchTeamExpl: {
    de: "Team Suchen (Name oder Liga ID)",
    it: "Team Suchen (Name oder Liga ID)",
    en: "Team Suchen (Name oder Liga ID)",
  },
  summary: {
    de: "Zusammenfassung",
    it: "Zusammenfassung",
    en: "Zusammenfassung",
  },
  thumbnailUrl: {
    de: "Link zum Vorschaubild",
    it: "Link per il preview",
    en: "Preview Link",
  },
  searchVideo: {
    de: "Nach Video suchen",
    it: "Nach Video suchen",
    en: "Nach Video suchen",
  },
  editVideo: {
    de: "Video Bearbeiten",
    it: "Video Bearbeiten",
    en: "Edit Video",
  },
  editBadge: {
    de: "Badge Bearbeiten",
    it: "Badge Bearbeiten",
    en: "Edit Badge",
  },
  deleteVideo: {
    de: "Video löschen",
    it: "Video löschen",
    en: "Delete Video",
  },
  deleteMatch: {
    de: "Spiel löschen",
    it: "Spiel löschen",
    en: "Delete Match",
  },
  createMatch: {
    de: "Spiel Erstellen",
    it: "Spiel Erstellen",
    en: "Create Match",
  },
  confirmSuccess: {
    de: "Erfolgreich bestätigt",
    it: "Erfolgreich bestätigt",
    en: "Erfolgreich bestätigt",
  },
  username: {
    de: "Benutzername",
    it: "Nome utente",
    en: "Username",
  },
  searchMatches: {
    de: "Nach Spiel Suchen",
    it: "Nach Spiel Suchen",
    en: "Nach Spiel Suchen",
  },
  searchLocation: {
    de: "Spielstätte (optional)",
    it: "Location (optional)",
    en: "Location (optional)",
  },
  reset: {
    de: "Zurücksetzen",
    it: "Reset",
    en: "Reset",
  },
  searchLeague: {
    de: "Liga",
    it: "Liga",
    en: "League",
  },
  searchTeam1: {
    de: "Heimmannschaft",
    it: "Heimmannschaft",
    en: "Home Team",
  },
  searchTeam2: {
    de: "Andere Mannschaft",
    it: "Andere Mannschaft",
    en: "Away Team",
  },
  matchNotFound: {
    de: "Spiel nicht gefunden",
    it: "Spiel nicht gefunden",
    en: "Spiel nicht gefunden",
  },
  filter: {
    de: "Filter",
    it: "Filter",
    en: "Filter",
  },
  time: {
    de: "Uhrzeit",
    it: "uhrzeit",
    en: "Uhrzeit",
  },
  selectAll: {
    de: "Alle auswählen",
    it: "Alle auswählen",
    en: "Alle auswählen",
  },
  team1: {
    de: "Heimmannschaft",
    it: "Heimmannschaft",
    en: "Heimmannschaft",
  },
  team2: {
    de: "Gegenmannschaft",
    it: "Gegenmannschaft",
    en: "Gegenmannschaft",
  },
  createSingle: {
    de: "Einzeln Erstellen",
    it: "Einzeln Erstellen",
    en: "Einzeln Erstellen",
  },
  createBulk: {
    de: "Spiele importieren",
    it: "Spiele importieren",
    en: "Spiele importieren",
  },
  unexpectedErrorReload: {
    de: "Ein unerwarteter Fehler ist aufgetreten, bitte Seite neu Laden",
    it: "Ein unerwarteter Fehler ist aufgetreten, bitte Seite neu Laden",
    en: "Ein unerwarteter Fehler ist aufgetreten, bitte Seite neu Laden",
  },
  uploadSheet: {
    de: "Liste hochladen ( Funktioniert nicht auf Safari )",
    it: "Liste hochladen ( Funktioniert nicht auf Safari )",
    en: "Liste hochladen ( Funktioniert nicht auf Safari )",
  },
  validateSheet: {
    de: "Auswerten",
    it: "Auswerten",
    en: "Auswerten",
  },
  allowedSheets: {
    de: "Folgene formate werden unterstützt: .xml, .xlsx, .csv",
    it: "Folgene formate werden unterstützt: .xml, .xlsx, .csv",
    en: "Folgene formate werden unterstützt: .xml, .xlsx, .csv",
  },
  couldNotParseFile: {
    de: "Datei [file] konnte nicht glesen werden",
    it: "Datei [file] konnte nicht glesen werden",
    en: "Datei [file] konnte nicht glesen werden",
  },
  wrongLine: {
    de: "[file]: Zeile [line] konnte nicht glesen werden",
    it: "[file]: Zeile [line] konnte nicht glesen werden",
    en: "[file]: Zeile [line] konnte nicht glesen werden",
  },
  wrongLineTooShort: {
    de: "[file]: Zeile [line] konnte nicht glesen werden: Zu wenig Spalten",
    it: "[file]: Zeile [line] konnte nicht glesen werden: Zu wenig Spalten",
    en: "[file]: Zeile [line] konnte nicht glesen werden: Zu wenig Spalten",
  },
  noMatchday: {
    de: "[file]: Zeile [line] konnte nicht glesen werden (Spieltag)",
    it: "[file]: Zeile [line] konnte nicht glesen werden (Spieltag)",
    en: "[file]: Zeile [line] konnte nicht glesen werden (Spieltag)",
  },
  downloadAppToRegister: {
    de: "Bitte lade die App um dich zu registrieren!",
    it: "Si prega di caricare l'app per registrarsi!",
    en: "Please load the app to register!",
  },
  downloadAppToConfirm: {
    de: "Bitte lade die App um dich zu verifizieren!",
    it: "Si prega di caricare l'app per registrarsi!",
    en: "Please load the app to register!",
  },
  probablyHeader: {
    de: "[file]: Header? auf Zeile [line] übersprungen",
    it: "[file]: Header? auf Zeile [line] übersprungen",
    en: "[file]: Header? auf Zeile [line] übersprungen",
  },
  generateReport: {
    de: "Playerscore generieren",
    it: "Calcola playerscore",
    en: "Generate playerscore",
  },
  reportGenerating: {
    de: "Playerscore wird generiert, er wird per E-Mail an [mail] geschickt!",
    it: "Il playerscore verrà generato e verrà inviato via email a [mail]!",
    en: "Playerscore will be generated, it will be emailed to [mail]!",
  },
  newMatch: {
    de: "Neues Spiel",
    it: "Neues Spiel",
    en: "Neues Spiel",
  },
  submitAll: {
    de: "Alle Senden",
    it: "Alle Senden",
    en: "Alle Senden",
  },
  searchAds: {
    de: "Nach Ad suchen",
    it: "Nach Ad suchen",
    en: "Nach Ad suchen",
  },
  editAd: {
    de: "Ad Bearbeiten",
    it: "Ad Bearbeiten",
    en: "Ad Bearbeiten",
  },
  deleteAd: {
    de: "Ad Löschen",
    it: "Ad Löschen",
    en: "Ad Löschen",
  },
  createAd: {
    de: "Ad Erstellen",
    it: "Ad Erstellen",
    en: "Ad Erstellen",
  },
  HOME_MATCH: {
    de: "Startseite",
    it: "Startseite",
    en: "Startseite",
  },
  MATCH_HISTORY_BOTTOM: {
    de: "Spielverlauf",
    it: "Spielverlauf",
    en: "Spielverlauf",
  },
  STANDINGS: {
    de: "Tabelle",
    it: "Tabelle",
    en: "Tabelle",
  },
  TEAM_OF_THE_WEEK: {
    de: "Team of the Week",
    it: "Team of the Week",
    en: "Team of the Week",
  },
  USER_FEED: {
    de: "Feed",
    it: "Feed",
    en: "Feed",
  },
  MATCH_FEED: {
    de: "Feed",
    it: "Feed",
    en: "Feed",
  },
  LEAGUE_MATCH_MATCH: {
    de: "Liga-Spiele",
    it: "Liga-Spiele",
    en: "Liga-Spiele",
  },
  adPosition: {
    de: "Posizion",
    it: "Position",
    en: "Position",
  },
  startDate: {
    de: "Start-Datum",
    it: "Start-Datum",
    en: "Start-Datum",
  },
  stopDate: {
    de: "End-Datum",
    it: "End-Datum",
    en: "End-Datum",
  },
  priority: {
    de: "Priorität",
    it: "Priorität",
    en: "Priorität",
  },
  paused: {
    de: "Pausiert",
    it: "Pausiert",
    en: "Pausiert",
  },
  color: {
    de: "Farbe",
    it: "Farbe",
    en: "Farbe",
  },
  uploadError: {
    de: "Fehler beim hochladen",
    it: "Fehler beim hochladen",
    en: "Fehler beim hochladen",
  },
  chooseEndpoint: {
    de: "Server wählen",
    it: "Scegli server",
    en: "Choose server",
  },
  server: {
    de: "Server",
    it: "Server",
    en: "Server",
  },
  serverDescription: {
    de: "Backend-Server ändern (nur für Admins)",
    it: "Cambia server backend (solo per admin)",
    en: "Change backend server (Admin only)",
  },
  deleteImageToChoose: {
    de: "Die Bilder müssen neu hochgeladen werden wenn die Posizion verändert wird, bitte löschen",
    it: "Die Bilder müssen neu hochgeladen werden wenn die Posizion verändert wird, bitte löschen",
    en: "Die Bilder müssen neu hochgeladen werden wenn die Posizion verändert wird, bitte löschen",
  },
  useSameFile: {
    de: "Gleiches Bild für Desktop und Mobile",
    it: "Gleiches Bild für Desktop und Mobile",
    en: "Gleiches Bild für Desktop und Mobile",
  },
  key: {
    de: "Admin Key",
    it: "Admin Key",
    en: "Admin Key",
  },
  league: {
    de: "Liga",
    it: "Liga",
    en: "Liga",
  },
  clearCache: {
    de: "Cache leeren ( Behebt manchmal Fehler )",
    it: "Cache leeren ( Behebt manchmal Fehler )",
    en: "Cache leeren ( Behebt manchmal Fehler )",
  },
  recalculateSqua: {
    de: "Spieler-Werte neu berechnen ( Gesp. Minuten, Tore, etc. )",
    it: "Spieler-Werte neu berechnen ( Gesp. Minuten, Tore, etc. )",
    en: "Spieler-Werte neu berechnen ( Gesp. Minuten, Tore, etc. )",
  },
  recalculateStat: {
    de: "Alle Statistiken neu berechnen",
    it: "Alle Statistiken neu berechnen",
    en: "Alle Statistiken neu berechnen",
  },
  taskCreateSuccess: {
    de: "Task erfolgreich erstellt",
    it: "Task erfolgreich erstellt",
    en: "Task erfolgreich erstellt",
  },
  taskCreateFailed: {
    de: "Task konnte nicht erstellt werden",
    it: "Task konnte nicht erstellt werden",
    en: "Task konnte nicht erstellt werden",
  },
  saveKey: {
    de: "Admin Key speichern",
    it: "Admin Key speichern",
    en: "Admin Key speichern",
  },
  transfer: {
    de: "Transfer",
    it: "Transfer",
    en: "Transfer",
  },
  errorTeam1: {
    de: "Heimmannschaft nicht gesetzt",
    it: "Heimmannschaft nicht gesetzt",
    en: "Heimmannschaft nicht gesetzt",
  },
  errorTeam2: {
    de: "Andere Mannschaft nicht gesetzt",
    it: "Andere Mannschaft nicht gesetzt",
    en: "Andere Mannschaft nicht gesetzt",
  },
  errorLeague: {
    de: "Liga nicht gesetzt",
    it: "Liga nicht gesetzt",
    en: "Liga nicht gesetzt",
  },
  errorDate: {
    de: "Datum nicht gesetzt",
    it: "Datum nicht gesetzt",
    en: "Datum nicht gesetzt",
  },
  errorDateCont: {
    de: "[file]: Zeile [line]: Datum nicht gesetzt",
    it: "[file]: Zeile [line]: Datum nicht gesetzt",
    en: "[file]: Zeile [line]: Datum nicht gesetzt",
  },
  matchSectionAmount: {
    de: "Anzahl Spielabschnitte",
    it: "Anzahl Spielabschnitte",
    en: "Anzahl Spielabschnitte",
  },
  matchSectionDurationMinutes: {
    de: "Dauer pro Spielabschnitt (min.)",
    it: "Dauer pro Spielabschnitt (min.)",
    en: "Dauer pro Spielabschnitt (min.)",
  },
  matchSectionPauseDurationMinutes: {
    de: "Dauer der Pause/n (min.)",
    it: "Dauer der Pause/n (min.)",
    en: "Dauer der Pause/n (min.)",
  },
  amountMatchDaysHalfSeason: {
    de: "Spieltage pro Saisonsrunde",
    it: "Spieltage pro Saisonsrunde",
    en: "Spieltage pro Saisonsrunde",
  },
  nameDE: {
    de: "Name Deutsch",
    it: "Name tedesco",
    en: "Name german",
  },
  nameIT: {
    de: "Name Italienisch",
    it: "Nome italiano",
    en: "Name italian",
  },
  nameEN: {
    de: "Name Englisch",
    it: "Nome inglese",
    en: "Name english",
  },
  descriptionDE: {
    de: "Beschreibung Deutsch",
    it: "Beschreibung tedesco",
    en: "Beschreibung german",
  },
  descriptionIT: {
    de: "Beschreibung Italienisch",
    it: "Beschreibung italiano",
    en: "Beschreibung italian",
  },
  descriptionEN: {
    de: "Beschreibung Englisch",
    it: "Beschreibung inglese",
    en: "Beschreibung english",
  },
  leagueCategory: {
    de: "Categorie",
    it: "Categoria",
    en: "Category",
  },
  leagueRating: {
    de: "Tabellenberechnung",
    it: "Tabellenberechnung",
    en: "Tabellenberechnung",
  },
  southtyrol: {
    de: "Südtirol",
    it: "Alto Adige",
    en: "Southtyrol",
  },
  trentino: {
    de: "Trient",
    it: "Trentino",
    en: "Trentino",
  },
  imprint: {
    de: "Impressum",
    it: "Impronta",
    en: "Imprint",
  },
  imprintRepresent: {
    de: "Gesetzlicher Vertreter",
    it: "Rappresentante legale",
    en: "Legal representative",
  },
  imprintStreet: {
    de: "Fasser 16/A",
    it: "Via Fasser 16/A",
    en: "Via Fasser 16/A",
  },
  imprintCity: {
    de: "39042 Brixen (BZ)",
    it: "39042 Bressanone (BZ)",
    en: "39042 Bressanone (BZ)",
  },
  imprintState: {
    de: "Italien",
    it: "Italia",
    en: "italy",
  },
  imprintPIva: {
    de: "MwSt.-Nr.",
    it: "Partita IVA",
    en: "VAT number",
  },
  imprintRegister: {
    de: "Eingetragen im Register der Handelskammer Bozen unter der Nummer",
    it: "Iscritta nel registro della Camera di Commercio di Bolzano con il numero",
    en: "Registered in the Chamber of Commerce of Bozen under number",
  },
  imprintDisclaimer: {
    de: "Haftungshinweis",
    it: "Disclaimer",
    en: "Disclaimer",
  },
  imprintDisclaimer1: {
    de: "Wir übernehmen keine Haftung für die Inhalte externer Links. Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich.",
    it: "Non ci assumiamo alcuna responsabilità per il contenuto dei link esterni. Gli operatori sono gli unici responsabili per il contenuto delle pagine collegate.",
    en: "We assume no liability for the content of external links. The operators are solely responsible for the content of the linked pages.",
  },
  imprintDisclaimer2: {
    de: "Wir sind bemüht, das Webangebot stets aktuell und inhaltlich richtig sowie vollständig anzubieten. Dennoch ist das Auftreten von Fehlern nicht völlig auszuschließen. Clava Sports übernimmt keine Haftung für die Aktualität, die inhaltliche Richtigkeit sowie für die Vollständigkeit der in ihrem Webangebot eingestellten Informationen. Dies bezieht sich auf eventuelle Schäden materieller oder ideeller Art Dritter, die durch die Nutzung dieses Webangebotes verursacht wurden.",
    it: "Ci impegniamo a garantire che il nostro sito web sia sempre aggiornato, accurato e completo in termini di contenuti. Tuttavia non è possibile escludere completamente che si verifichino errori. Clava Sports non si assume alcuna responsabilità per la tempestività, l'accuratezza del contenuto o la completezza delle informazioni fornite sul proprio sito web. Ciò si riferisce a qualsiasi danno materiale o immateriale causato a terzi dall'uso di questo sito web.",
    en: "We strive to ensure that our website is always up to date, accurate and complete in terms of content. However, the occurrence of errors cannot be completely ruled out. Clava Sports assumes no liability for the timeliness, the accuracy of the content or the completeness of the information provided on its website. This refers to any material or immaterial damage to third parties caused by the use of this website.",
  },
  imprintDisclaimer3: {
    de: "Geschützte Marken und Namen, Bilder und Texte werden auf unseren Seiten in der Regel nicht als solche kenntlich gemacht. Das Fehlen einer solchen Kennzeichnung bedeutet jedoch nicht, dass es sich um einen freien Namen, ein freies Bild oder einen freien Text im Sinne des Markenzeichenrechts handelt.",
    it: "Marchi e nomi, immagini e testi protetti generalmente non vengono identificati come tali sulle nostre pagine. Tuttavia, l'assenza di tale contrassegno non significa che si tratti di un nome, di un'immagine o di un testo liberi ai sensi del diritto dei marchi.",
    en: "Protected brands and names, images and texts are generally not identified as such on our pages. However, the absence of such marking does not mean that it is a free name, a free image or a free text within the meaning of trademark law.",
  },
  imprintRights: {
    de: "Nutzungsrechte",
    it: "Diritti d'uso",
    en: "Rights of use",
  },
  imprintAllRightsReserved: {
    de: "Alle Rechte vorbehalten.",
    it: "Tutti i diritti riservati.",
    en: "All rights reserved.",
  },
  imprintRights1: {
    de: "Ein Download oder Ausdruck dieser Veröffentlichungen ist ausschließlich für den persönlichen Gebrauch gestattet. Alle darüber hinaus gehenden Verwendungen, insbesondere die kommerzielle Nutzung und Verbreitung, sind grundsätzlich nicht gestattet und bedürfen der schriftlichen Genehmigung.",
    it: "È consentito scaricare o stampare queste pubblicazioni solo per uso personale. Tutti gli usi successivi, in particolare l'uso commerciale e la distribuzione, generalmente non sono consentiti e richiedono un'autorizzazione scritta.",
    en: "Downloading or printing these publications is permitted for personal use only. All uses beyond this, in particular commercial use and distribution, are generally not permitted and require written permission.",
  },
  year: {
    de: "Jahr",
    it: "Anno",
    en: "Year",
  },
  mainLeague: {
    de: "Hauptliga",
    it: "Hauptliga",
    en: "Main league",
  },
  editLeague: {
    de: "Liga bearbeiten",
    it: "Liga bearbeiten",
    en: "Liga bearbeiten",
  },
  duplicateLeague: {
    de: "Liga duplizieren",
    it: "Liga duplizieren",
    en: "Liga duplizieren",
  },
  deactivateOld: {
    de: "Alte Deaktivieren",
    it: "Alte Deaktivieren",
    en: "Deactivate old",
  },
  deleteLeague: {
    de: "Liga löschen",
    it: "Liga löschen",
    en: "Liga löschen",
  },
  searchLeagues: {
    de: "Nach Liga suchen",
    it: "Nach Liga suchen",
    en: "Nach Liga suchen",
  },
  createLeague: {
    de: "Liga erstellen",
    it: "Liga erstellen",
    en: "Liga erstellen",
  },
  searchMatchExpl: {
    de: "Suche (Spiele oder SpielID)",
    it: "Suche (Spiele oder SpielID)",
    en: "Suche (Spiele oder SpielID)",
  },
  giveBadge: {
    de: "Badge geben",
    it: "Badge geben",
    en: "Badge geben",
  },
  createBadge: {
    de: "Badge erstellen",
    it: "Badge erstellen",
    en: "Badge erstellen",
  },
  removeBadge: {
    de: "Badge nehmen",
    it: "Badge nehmen",
    en: "Badge nehmen",
  },
  acceptAgb1: {
    de: "Hiermit bestätige ich dass ich die ",
    it: "Con la presente confermo di avere il ",
    en: "I hereby confirm that I have the ",
  },
  acceptAgb2: {
    de: " und die ",
    it: " e il ",
    en: " and the ",
  },
  acceptAgb3: {
    de: " gelesen habe und akzeptiere sie!",
    it: " ho letto e accetto!",
    en: " have read and accept them!",
  },
  wantNewsletter: {
    de: "Ich möchte Emails mit Neuigkeiten und Informationen rund um Clava erhalten",
    it: "Desidero ricevere e-mail con notizie e informazioni su Clava",
    en: "I would like to receive emails with news and information about Clava",
  },
  telGiven: {
    de: "Telefonnummer bereits vergeben",
    it: "Numero già utilizzato",
    en: "Phone number already taken",
  },
  telInvalid: {
    de: "Telefonnummer Adresse ungültig",
    it: "Numero non valido",
    en: "Phone number invalid",
  },
  searchUsers: {
    de: "Nach Benutzer suchen",
    it: "Nach Benutzer suchen",
    en: "Nach Benutzer suchen",
  },
  availableBadges: {
    de: "Verfügbare Badges:",
    it: "Verfügbare Badges:",
    en: "Verfügbare Badges:",
  },
  changeOutcome: {
    de: "Ergebniss ändern",
    it: "Ergebniss ändern",
    en: "Ergebniss ändern",
  },
  changeOutcomeCont: {
    de: "Es werden Tore ohne Torschütze in die 90. Minute hinzugefügt, bzw. Tore gelöscht",
    it: "Es werden Tore ohne Torschütze in die 90. Minute hinzugefügt, bzw. Tore gelöscht",
    en: "Es werden Tore ohne Torschütze in die 90. Minute hinzugefügt, bzw. Tore gelöscht",
  },
  goal1: {
    de: "Heim",
    it: "Heim",
    en: "Heim",
  },
  goal2: {
    de: "Gast",
    it: "Gast",
    en: "Gast",
  },
  goals1: {
    de: "Tore Heim",
    it: "Tore Heim",
    en: "Tore Heim",
  },
  goals2: {
    de: "Tore Gast",
    it: "Tore Gast",
    en: "Tore Gast",
  },
  leagueNotFound: {
    de: "Liga nicht gefunden",
    it: "Liga nicht gefunden",
    en: "Liga nicht gefunden",
  },
  applyFilter: {
    de: "Filter anwenden",
    it: "Filter anwenden",
    en: "Filter anwenden",
  },
  bulkActions: {
    de: "Massenaktionen",
    it: "Massenaktionen",
    en: "Massenaktionen",
  },
  selectedMatches: {
    de: "Ausgewählt:",
    it: "Ausgewählt:",
    en: "Ausgewählt:",
  },
  unsavedChanges: {
    de: "[numChanges] ungespeichtere Änderungen",
    it: "[numChanges] ungespeichtere Änderungen",
    en: "[numChanges] ungespeichtere Änderungen",
  },
  noUnsavedChanges: {
    de: "Keine Änderungen",
    it: "Keine Änderungen",
    en: "Keine Änderungen",
  },
  saveChanges: {
    de: "Änderungen speichern",
    it: "Änderungen speichern",
    en: "Änderungen speichern",
  },
  matchActions: {
    de: "Aktionen",
    it: "Aktionen",
    en: "Aktionen",
  },
  saveSuccess: {
    de: "Erfolgreich gespeichert",
    it: "Erfolgreich gespeichert",
    en: "Erfolgreich gespeichert",
  },
  deleteSuccess: {
    de: "Erfolgreich gelöscht",
    it: "Erfolgreich gelöscht",
    en: "Erfolgreich gelöscht",
  },
  deleteFailed: {
    de: "Löschen fehlgeschlagen",
    it: "Löschen fehlgeschlagen",
    en: "Löschen fehlgeschlagen",
  },
  saveFailed: {
    de: "Etwas ist schief gelaufen",
    it: "Etwas ist schief gelaufen",
    en: "Etwas ist schief gelaufen",
  },
  discardUnsavedChanges: {
    de: "Du hast ungespeicherte Änderungen!",
    it: "Du hast ungespeicherte Änderungen!",
    en: "Du hast ungespeicherte Änderungen!",
  },
  discardChanges: {
    de: "Änderungen verwerfen",
    it: "Änderungen verwerfen",
    en: "Änderungen verwerfen",
  },
  titleDE: {
    de: "Titel DE",
    it: "Titolo DE",
    en: "Title DE",
  },
  titleIT: {
    de: "Titel IT",
    it: "Titolo IT",
    en: "Title IT",
  },
  titleEN: {
    de: "Titel EN",
    it: "Titolo EN",
    en: "Title EN",
  },
  summaryDE: {
    de: "Zusammenfassung DE",
    it: "Sommario DE",
    en: "Summary DE",
  },
  summaryIT: {
    de: "Zusammenfassung IT",
    it: "Sommario IT",
    en: "Summary IT",
  },
  summaryEN: {
    de: "Zusammenfassung EN",
    it: "Sommario EN",
    en: "Summary EN",
  },
  bodyDE: {
    de: "Text DE",
    it: "Testo DE",
    en: "Body DE",
  },
  bodyIT: {
    de: "Text IT",
    it: "Testo IT",
    en: "Body IT",
  },
  bodyEN: {
    de: "Text EN",
    it: "Testo EN",
    en: "Body EN",
  },
  uid: {
    de: "Eindeutige ID",
    it: "ID Unica",
    en: "Unique ID",
  },
  watchApp: {
    de: "Vieles mehr in der Clava Sports App",
    it: "Scarica l'app Clava Sports",
    en: "Download Clava Sports App",
  },
  loadApp: {
    de: "Lade dir die Clava Sports App herunter",
    it: "Scarica l'app Clava Sports",
    en: "Download Clava Sports App",
  },
  statisticsInApp: {
    de: "Statistiken und mehr findest du in der Clava Sports App",
    it: "Scarica l'app Clava Sports e puoi trovare statistiche e altro",
    en: "Download Clava Sports App and find statistics and more",
  },
  themedark: {
    de: "Light Mode",
    it: "Light mode",
    en: "Light mode",
  },
  themelight: {
    de: "Dark Mode",
    it: "Dark mode",
    en: "Dark mode",
  },
  feed: {
    de: "Feed",
    it: "Feed",
    en: "Feed",
  },
  successCreate: {
    de: "Erfolgreich erstellt",
    it: "Erfolgreich erstellt",
    en: "Erfolgreich erstellt",
  },
  successEdit: {
    de: "Erfolgreich bearbeitet",
    it: "Erfolgreich bearbeitet",
    en: "Erfolgreich bearbeitet",
  },
  successDelete: {
    de: "Erfolgreich gelöscht",
    it: "Erfolgreich gelöscht",
    en: "Erfolgreich gelöscht",
  },
  matchTaskRunning: {
    de: "Spiele werden überprüft...",
    it: "Giochi veranno controllato...",
    en: "Matches are being checked...",
  },
  dryRun: {
    de: "Überprüfen",
    it: "Controlla",
    en: "Check over",
  },
  line: {
    de: "Zeile",
    it: "Linea",
    en: "Line",
  },
  followingWillCreate: {
    de: "Folgende Spiele werden erstellt: Zeile ",
    it: "I seguenti vengono creati: linea ",
    en: "The following are created: line ",
  },
  noImport: {
    de: "Bitte keine anderen Aktionen vornehmen wenn ein Import gemacht wird",
    it: "Si prega di non intraprendere altre azioni quando viene effettuata un'importazione",
    en: "Please do not take any other actions when an import is made",
  },
  strangeTaskError: {
    de: "Der Server hat seit über 10 Sekunden keinen Status Update geschickt... Etwas ist schief gelaufen!",
    it: "Il server non ha inviato un aggiornamento di stato per più di 10 secondi... Qualcosa è andato storto!",
    en: "The server hasn't sent a status update for over 10 seconds... Something went wrong!",
  },
  cup: {
    de: "Turnier",
    it: "Torneo",
    en: "Cup",
  },
  CupInfo: {
    de: "Übersicht",
    it: "Panoramica",
    en: "Overview",
  },
  CupTable: {
    de: "Tabelle",
    it: "Classifica",
    en: "Table",
  },
  CupGroupStage: {
    de: "Gruppenphase",
    it: "Fase a gruppi",
    en: "Group stage",
  },
  CupKnockoutStage: {
    de: "Knockout",
    it: "Eliminazione",
    en: "Knockout",
  },
  CupLooserBracket: {
    de: "Verliererrunde",
    it: "Girone perdenti",
    en: "Loser Bracket",
  },
  scrollToSee: {
    de: "L/R wischen, um alle Spiele anzuzeigen",
    it: "Scorri s/d per vedere tutte le partite",
    en: "Swipe left to right to see all matches",
  },
  group: {
    de: "Gruppe",
    it: "Gruppo",
    en: "Group",
  },
  cupDetails: {
    de: "Turnierdetails",
    it: "Dettagli sul torneo",
    en: "Cup Details",
  },
  numOfTeams: {
    de: "Anzahl der Mannschaften",
    it: "Numero di squadre",
    en: "Number of Teams",
  },
  price: {
    de: "Preis",
    it: "Premio",
    en: "Price",
  },
  regulation: {
    de: "Reglement",
    it: "Regolamento",
    en: "Regulation",
  },
  moreInfoCup: {
    de: "Alle Infos",
    it: "Tutte le info",
    en: "Find more info",
  },
  linkToMoreInfo: {
    de: "Link für weitere Informationen",
    it: "Link per maggiori informazioni",
    en: "Link for more info",
  },
  cupTeamA: {
    de: "Mannschaft A oder Platzhalter",
    it: "Squadra A o segnaposto",
    en: "Team A or placeholder",
  },
  cupTeamB: {
    de: "Mannschaft B oder Platzhalter",
    it: "Squadra B o segnaposto",
    en: "Team B or placeholder",
  },
  addGroup: {
    de: "Gruppe hinzufügen",
    it: "Aggiungi gruppo",
    en: "Add Group",
  },
  editGroup: {
    de: "Gruppe bearbeiten",
    it: "Modifica gruppo",
    en: "Edit Group",
  },
  addStage: {
    de: "Phase erstellen",
    it: "Crea nuova fase",
    en: "Create new stage",
  },
  editStage: {
    de: "Phase bearbeiten",
    it: "Modifica fase",
    en: "Edit stage",
  },
  predefinedKnockout: {
    de: "Vordefiniertes System",
    it: "Sistema predefinito",
    en: "Predefined System",
  },
  withoutPredefined: {
    de: "Ohne System",
    it: "Senza sistema",
    en: "Without System",
  },
  predefinedKnockoutCont: {
    de: "Wähle ein gewünschtes System aus. Es werden alle Spiele mit Standardvariablen erstellt. Diese kannst du im Nachhinein noch ganz einfach bearbeiten!",
    it: "Seleziona il sistema che desideri. Tutti i giochi sono creati con variabili standard che potrai facilmente modificare in seguito!",
    en: "Select the system you want. All games are created with standard variables, which you can easily edit afterwards!",
  },
  quarters: {
    de: "Standard-Baum ab Viertelfinale",
    it: "Albero standard dai quarti di finale",
    en: "Standard tree starting from round of 8",
  },
  eights: {
    de: "Standard-Baum ab Achtelfinale",
    it: "Albero standard dagli ottavi di finale",
    en: "Standard tree starting from round of 16",
  },
  sixteenth: {
    de: "Standard-Baum ab Sechzehntelfinale",
    it: "Albero standard dai sedicesimi di finale",
    en: "Standard tree starting from round of 32",
  },
  matchMode: {
    de: "Spielmodus",
    it: "Modalità di gioco",
    en: "Match Mode",
  },
  playedWithoutPause: {
    de: "Es wird [mins] Minuten ohne Halbzeit gespielt.",
    it: "La partita si gioca per [mins] minuti senza intervallo.",
    en: "The game is played for [mins] minutes without half-time.",
  },
  playedWithPause: {
    de: "Es wird 2 x [mins] Minuten gespielt mit [pause] Minuten Halbzeitpause.",
    it: "La partita si gioca per 2 x [mins] minuti con una pausa di [pause] minuti a metà tempo.",
    en: "The game will be played 2 x [mins] minutes with a [pause] minute half-time break.",
  },
  sectionPause: {
    de: "Halbzeitpause in Minuten",
    it: "Pausa intervallo in minuti",
    en: "Halftime break in minutes",
  },
  pauseBetweenMatches: {
    de: "Pause zwischen Spielen in Minuten",
    it: "Pausa tra le partite in minuti",
    en: "Break between games in minutes",
  },
  startTimeFirst: {
    de: "Wann startet das erste Spiel?",
    it: "Quando inizia la prima partita?",
    en: "When does the first match start?",
  },
  matchesParalell: {
    de: "Wie viele Spiele können zeitgleich gespielt werden?",
    it: "Quante partite si possono giocare contemporaneamente?",
    en: "How many games can be played at the same time?",
  },
  groupName: {
    de: "Gruppenname",
    it: "Nome del gruppo",
    en: "Group Name",
  },
  stageName: {
    de: "Phasenname",
    it: "Nome della fase",
    en: "Phase Name",
  },
  noStandings: {
    de: "Keine Tabelle",
    it: "Nessuna classifica",
    en: "No table",
  },
  removeTeam: {
    de: "Mannschaft entfernen",
    it: "Rimuovi squadra",
    en: "Remove Team",
  },
  sureWantRemoveTeam: {
    de: "Bist du sicher, dass du die Mannschaft aus dieser Gruppe entfernen möchtest?",
    it: "Sei sicuro di voler rimuovere la squadra da questo gruppo?",
    en: "Are you sure you want to remove the team from this group?",
  },
  addCupTeam: {
    de: "Mannschaft hinzufügen",
    it: "Aggiungi squadra",
    en: "Add Team",
  },
  editCupTeam: {
    de: "Team bearbeiten",
    it: "Modifica squadra",
    en: "Edit Team",
  },
  addCupTeamGroup: {
    de: "Team hinzufügen",
    it: "Aggiungi team",
    en: "Add Team",
  },
  teamName: {
    de: "Mannschaftsname",
    it: "Nome della squadra",
    en: "Team name",
  },
  matchDate: {
    de: "Datum und Uhrzeit",
    it: "Data e ora",
    en: "Match date and time",
  },
  create: {
    de: "Erstellen",
    it: "Crea",
    en: "Create",
  },
  duration: {
    de: "Dauer in Minuten",
    it: "Durata in minuti",
    en: "Duration in minutes",
  },
  cupLocation: {
    de: "Ort",
    it: "Località",
    en: "Location",
  },
  successInsider: {
    de: "Erfolgreich",
    it: "Successo",
    en: "Success",
  },
  alreadyRight: {
    de: "Du hast bereits diese Rechte",
    it: "Hai già questi diritti",
    en: "You already have these rights",
  },
  cupAdmin: {
    de: "Administrator",
    it: "Amministratore",
    en: "Administrator",
  },
  cupManager: {
    de: "Manager",
    it: "Manager",
    en: "Manager",
  },
  cupSecretsExpl: {
    de: "Das sind die Geheimcodes für dein Turnier. Administratoren können das ganze Turnier bearbeiten. Manager können deren Mannschaft bearbeiten und Tore eintragen.",
    it: "Ecco i codici segreti per il tuo torneo. Gli amministratori possono modificare l'intero torneo. I manager possono modificare la loro squadra e inserire i goal.",
    en: "Here are the secret codes for your tournament. Administrators can edit the entire tournament. Managers can edit their team and enter the goals.",
  },
  adminCode: {
    de: "Code für Administratoren",
    it: "Codice per gli amministratori",
    en: "Code for administrators",
  },
  managerCode: {
    de: "Code für Manager",
    it: "Codice per i manager",
    en: "Code for managers",
  },
  beAdmin: {
    de: "Werde Administartor des Turnier",
    it: "Diventa amministratore del torneo",
    en: "Be tournament admin",
  },
  beManager: {
    de: "Werde Manager deiner Mannschaft",
    it: "Diventa manager della tua squadra",
    en: "Be tournament manager",
  },
  beAdminCont: {
    de: "Der Turnier-Adminstrator kann alle Informationen und Einstellungen des Turniers bearbeiten.",
    it: "L'amministratore del torneo può modificare tutte le informazioni e le impostazioni del torneo.",
    en: "Tournament admin can edit all information and settings of the tournament.",
  },
  beManagerCont: {
    en: "The manager can edit their team and matches and enter goals.",
    it: "Il manager può modificare la sua squadra e le partite e inserire dei goals.",
    de: "Der Manager kann sein Team und dessen Spiele bearbeiten, sowie Tore eintragen.",
  },
  apply: {
    de: "Bewerben",
    it: "Richiedi",
    en: "Apply",
  },
  cupSettings: {
    de: "Turniereinstellungen",
    it: "Impostazioni torneo",
    en: "Tournament Settings",
  },
  cupEdit: {
    de: "Grunddaten bearbeiten",
    it: "Modifica dati di base",
    en: "Edit base data",
  },
  cupDetailsEdit: {
    de: "Turnierdetails bearbeiten",
    it: "Modifica dettagli del torneo",
    en: "Edit tournament details",
  },
  cupInsider: {
    de: "Turnier verwalten",
    it: "Gestisci il torneo",
    en: "Cup Insider",
  },
  createCup: {
    de: "Jetzt erstellen",
    it: "Crea ora",
    en: "Create now",
  },
  cupTo: {
    de: "Enddatum",
    it: "Data di fine",
    en: "End date",
  },
  cupFrom: {
    de: "Startdatum",
    it: "Data d'inizio",
    en: "Start date",
  },
  cupCreate: {
    de: "Turnier erstellen",
    it: "Crea torneo",
    en: "Create tournament",
  },
  cupName: {
    de: "Name des Turniers",
    it: "Nome del torneo",
    en: "Name of the tournament",
  },
  location: {
    de: "Austragungsort",
    it: "Luogo",
    en: "Venue",
  },
  inNoGroupYet: {
    de: "Das Team ist keiner Gruppe zugeteilt. Die Tabelle wird berechnet, sobald das Team einer Gruppe zugeordnet wird!",
    it: "La squadra non è presente in uno dei gruppi. La classifica viene calcolata non appena la squadra viene assegnata ad un gruppo!",
    en: "The team is not in a group, the table is calculated as soon as the team is assigned to a group!",
  },
  teamPhoto: {
    de: "Teamfoto",
    it: "Foto di squadra",
    en: "Team photo",
  },
  fullName: {
    de: "Spielername",
    it: "Nome del giocatore",
    en: "Player name",
  },
  advancements: {
    de: "Qualifikationsregeln",
    it: "Regole di qualificazione",
    en: "Qualification rules",
  },
  QUALIFY: {
    de: "Qualifizieren sich für die nächste Runde",
    it: "Qualificarsi per il turno successivo",
    en: "Qualify for the next round",
  },
  PLAY_TO_QUALIFY: {
    de: "Spielt um Qualifikation",
    it: "Gioca per la qualificazione",
    en: "Plays for qualification",
  },
  PLAY_TO_DESCEND: {
    de: "Spielt um den Abstieg",
    it: "Gioca per la retrocessione",
    en: "Plays for relegation",
  },
  DESCEND: {
    de: "Steigt ab",
    it: "Retrocede",
    en: "Relegates",
  },
  DOES_NOT_QUALIFY: {
    de: "Qualifizieren sich nicht",
    it: "Non si qualifica",
    en: "Does not qualify for the next round",
  },
  stage: {
    de: "Runde",
    it: "Turno",
    en: "Round",
  },
  matchDetails: {
    de: "Spieldetails",
    it: "Dettagli della partita",
    en: "Match details",
  },
  deleteTeam: {
    de: "Mannschaft löschen",
    it: "Elimina Squadra",
    en: "Delete Team",
  },
  viewMode: {
    de: "Ansichtsmodus",
    it: "Modalità visualizzazione",
    en: "View mode",
  },
  editMode: {
    de: "Bearbeitungsmodus",
    it: "Modalità modifica",
    en: "Edit mode",
  },
  details: {
    de: "Detailmodus",
    it: "Modalità dettagli",
    en: "Details mode"
  },
  webwidgets: {
    de: "Web-Widgets",
    it: "Web-Widgets",
    en: "Web-Widgets"
  },
  squad: {
    de: "Kader",
    it: "Rosa",
    en: "Squad"
  },
  newPlayer: {
    de: "Neuer Spieler",
    it: "Nuovo giocatore",
    en: "New Player"
  },
  keeper: {
    de: "Torwart",
    it: "Portiere",
    en: "Goalkeeper"
  },
  defender: {
    de: "Verteidiger",
    it: "Difensore",
    en: "Defender"
  },
  midfield: {
    de: "Mittelfeld",
    it: "Centrocampo",
    en: "Midfield"
  },
  offense: {
    de: "Stürmer",
    it: "Attaccante",
    en: "Offense"
  },
  keeperCA5: {
    de: "Torwart",
    it: "Portiere",
    en: "Goalkeeper"
  },
  defenderCA5: {
    de: "Centrale",
    it: "Centrale",
    en: "Defender"
  },
  midfieldCA5: {
    de: "Laterale",
    it: "Laterale",
    en: "Winger"
  },
  offenseCA5: {
    de: "Pivot",
    it: "Pivot",
    en: "Pivot"
  },
  birthday: {
    de: "Geburtstag",
    it: "Data di nascita",
    en: "Birthday"
  },
  age: {
    de: "Alter",
    it: "Età",
    en: "Age"
  },
  position: {
    de: "Position",
    it: "Posizione",
    en: "Position"
  },
  matriculationNumber: {
    de: "Matrikelnummer",
    it: "Numero di matricola",
    en: "Matriculation Number"
  },
  height: {
    de: "Größe",
    it: "Altezza",
    en: "Height"
  },
  LEFT: {
    de: "Links",
    it: "Sinistro",
    en: "Left"
  },
  preferredFoot: {
    de: "Fuß",
    it: "Piede",
    en: "Foot"
  },
  RIGHT: {
    de: "Rechts",
    it: "Destro",
    en: "Right"
  },
  BOTH: {
    de: "Beide",
    it: "Entrambi",
    en: "Both"
  },
  left: {
    de: "Links",
    it: "Sinistro",
    en: "Left"
  },
  right: {
    de: "Rechts",
    it: "Destro",
    en: "Right"
  },
  both: {
    de: "Beide",
    it: "Entrambi",
    en: "Both"
  },
  seniorCareer: {
    de: "Senior Karriere",
    it: "Carriera Senior",
    en: "Senior Career"
  },
  youthCareer: {
    de: "Jugend Karriere",
    it: "Carriera Giovanile",
    en: "Youth Career"
  },
  noCareerAvailable: {
    de: "Keine Karriere verfügbar",
    it: "Nessuna carriera disponibile",
    en: "No career available"
  },
  verifiedEntry: {
    de: "Verifizierter Eintrag",
    it: "Voce verificata",
    en: "Verified entry"
  },
  createdByPlayer: {
    de: "Vom Spieler erstellt",
    it: "Creata dal giocatore",
    en: "Entry created by player"
  },
  edit: {
    de: "Bearbeiten",
    it: "Modifica",
    en: "Edit"
  },
  deletePlayer: {
    de: "Spieler entfernen",
    it: "Rimuovi giocatore",
    en: "Remove player"
  },
  nextMatch: {
    de: "Nächstes Spiel",
    it: "Prossima partita",
    en: "Next Match"
  },
  embed: {
    de: "Einbetten",
    it: "Incorpora",
    en: "Embed"
  },
  onlyInsider: {
    de: "Dieser Bereich ist nur für Insider",
    it: "Quest'area è riservata ai Team Manager",
    en: "This area is only for Team Managers"
  },

  selectDocument: {
    de: "Dokument auswählen",
    it: "Seleziona documento",
    en: "Select document"
  },
  selectImage: {
    de: "Bild auswählen",
    it: "Seleziona immagine",
    en: "Select image"
  },
  selectGif: {
    de: "Animation auswählen",
    it: "Seleziona animazione",
    en: "Select animation"
  },
  selectVideo: {
    de: "Video auswählen",
    it: "Seleziona video",
    en: "Select video"
  },
  selectMedia: {
    de: "Medien auswählen",
    it: "Seleziona media",
    en: "Select media"
  },
  mediathek: {
    de: "Mediathek",
    it: "Mediathek",
    en: "Mediathek"
  },
  sureLeave: {
    de: "Sicher, dass du die Seite verlassen möchtest? Es gibt nicht gespeicherte Änderungen!",
    it: "Sicuro di voler lasciare la pagina? Ci sono modifiche non salvate!",
    en: "Are you sure you want to leave? You have unsaved changes!"
  },
  close: {
    de: "Schließen",
    it: "Chiudi",
    en: "Close"
  },
  stayHere: {
    de: "Hier bleiben",
    it: "Rimani qui",
    en: "Stay here"
  },
  uploadTeamEmblem: {
    de: "Vom Server zuschneiden lassen",
    it: "Chiedi al server di ritagliarlo",
    en: "Crop from server"
  },
  noFilesInMediathek: {
    de: "Keine Dateien in der Mediathek vorhanden!",
    it: "Nessun file nel catalogo multimediale!",
    en: "No files available in the media library!"
  },
  imageTooBig: {
    de: "Die Datei ist zu groß, max. 200MB",
    it: "Il file è troppo grande, massimo 200 MB",
    en: "The file is too large, max. 200MB"
  },
  uploadFailed: {
    de: "Upload fehlgeschlagen",
    it: "Upload non riuscito",
    en: "Upload failed"
  },
  uploadOrDragNDrop: {
    de: "Wähle eine Datei aus oder ziehe sie in dieses Feld",
    it: "Seleziona o trascina un file in questo campo",
    en: "Select a file or drag it into this field"
  },
  dropImageHere: {
    de: "Datei hier ablegen",
    it: "Rilascia il file qui",
    en: "Drop File here"
  },
  wrongFileType: {
    de: "Unzulässiger Dateityp! Erlaubte Formate:",
    it: "Tipo di file non valido! Tipi valido:",
    en: "Invalid file type! Valid types:"
  },
  bothTeams: {
    de: "Spielt bei beiden Teams",
    it: "Gioca in entrambe le squadre",
    en: "Plays for both teams"
  },
  hasDuplicate: {
    de: "Es gibt bereits einen Spieler mit den angegebenen Daten",
    it: "Esiste già un giocatore con i dati inseriti",
    en: "A player with the given data already exists"
  },
  ignoreDuplicate: {
    de: "Trotzdem neu erstellen",
    it: "Crea comunque un nuovo giocatore",
    en: "Create anyway"
  }, browserLang: {
    de: "Automatisch erkennen",
    it: "Rilevamento automatico",
    en: "Auto Detect"
  },
  widthWidget: {
    de: "Breite",
    it: "Larghezza",
    en: "Width"
  },
  teamMatches: {
    de: "Alle Spiele",
    it: "Tutte le partite",
    en: "All Matches"
  },
  teamManagement: {
    de: "Team Verwaltung",
    it: "Gestione Squadra",
    en: "Team Management"
  },
  teamManagementPromo: {
    de: "Pflege deinen Kader zentral und teile wichtige Teamdaten ganz einfach über unsere Webwidgets.",
    it: "Gestisci in modo centralizzato la tua rosa e condividi facilmente i dati importanti della squadra tramite i nostri web widget.",
    en: "Manage your squad centrally and share key team data effortlessly through our web widgets."
  },
  selectRegion: {
    de: "Region auswählen",
    it: "Seleziona Regione",
    en: "Select Region",
  },
  selectProvince: {
    de: "Province auswählen",
    it: "Seleziona Provincia",
    en: "Select Province",
  },
  emptyString: {
    de: "",
    it: "",
    en: "",
  },
  allGroups: {
    de: "Alle Gruppen",
    it: "Tutti i gironi",
    en: "All groups",
  },
  contacts: {
    de: "Kontakte",
    it: "Contatti",
    en: "Contacts",
  },
  panoramica: {
    de: "Übersicht",
    it: "Panoramica",
    en: "Overview",
  },
  president: {
    de: "Präsident",
    it: "Presidente",
    en: "President",
  },
  email: {
    de: "E-Mail",
    it: "E-mail",
    en: "Email",
  },
  phone: {
    de: "Telefon",
    it: "Telefono",
    en: "Phone",
  },
  instagram: {
    de: "Instagram",
    it: "Instagram",
    en: "Instagram",
  },
  facebook: {
    de: "Facebook",
    it: "Facebook",
    en: "Facebook",
  },
  sponsorInvalidLink: {
    de: "Konnte nicht gespeichert werden, da der Link ungültig ist",
    it: "Non può essere salvato perché il link non è valido",
    en: "Could not be saved because link is not valid",
  },
};

export declare type TranslatorKeys = keyof typeof generalKeywords;
export type Translatable = CollectionType &
  (
    | {
        name: Translation;
      }
    | {
        customName: string;
      }
  );
const keywords: Keywords = { ...generalKeywords };

export function translate(
  key: TranslatorKeys | Translation | TranslationCreate,
  lang: LanguageLocaleEnum,
  params?: { [T in string]: string }
): string {
  if (typeof key === "object") return showTranslated(key, lang);
  const keyword: Keyword = keywords[key];

  if (typeof keyword === "undefined") {
    return key;
  }
  if (params === undefined) {
    return keyword[lang];
  }
  let text = keyword[lang];
  const paramKeys = Object.keys(params);
  paramKeys.forEach((param) => {
    text = text.replace(param, params[param]);
  });
  return text;
}

/**
 *
 * @param translation
 * @param lang
 */
export function showTranslated(
  translation: Translation | TranslationCreate,
  lang: LanguageLocaleEnum
): string {
  switch (lang) {
    case "de":
      return translation.textDE;
    case "en":
      return translation.textEN;
    case "it":
      return translation.textIT;
    default:
      return translation.textIT;
  }
}
